/* eslint-disable quotes */
import {
  DOG_GROOMING_SERVICE_ID,
  DOG_TRAINING_SERVICE_ID,
  DOG_WALKING_SERVICE_ID,
  HOUSE_VISITING_SERVICE_ID,
  PET_DAY_CARE_SERVICE_ID,
  PET_HOSTING_SERVICE_ID,
  PET_SITTING_SERVICE_ID,
} from './app';

import type { BadgeIcons } from '@madpaws/design-system';

export const DEFAULT_PAGE_SIZE = 20;

export const searchServiceSlugMapping: { [key: string]: number } = {
  petsitters: PET_HOSTING_SERVICE_ID,
  petminding: PET_SITTING_SERVICE_ID,
  doggydaycare: PET_DAY_CARE_SERVICE_ID,
  housevisits: HOUSE_VISITING_SERVICE_ID,
  dogwalkers: DOG_WALKING_SERVICE_ID,
  doggroomers: DOG_GROOMING_SERVICE_ID,
  dogtrainers: DOG_TRAINING_SERVICE_ID,
};

export const DEFAULT_SERVICE_SLUG = 'petsitters';
export const DEFAULT_SEARCH_PAGE_SLUG = `/${DEFAULT_SERVICE_SLUG}/sydney-nsw`;

export const EMPTY_SERVICE_TYPE_ID = 0;
export const EMPTY_SERVICE = { type: '', quantity: 0 };

export const SERVICE_TYPE_BY_NAME_MAPPING: {
  [key: string]: {
    id: number;
    seoTitle: string;
    serviceJob: string;
    serviceName: string;
    serviceTitle: string;
  };
} = {
  petsitters: {
    id: PET_HOSTING_SERVICE_ID,
    serviceName: 'Pet Sitting',
    serviceTitle: 'Pet Sitting & Home Dog Boarding',
    serviceJob: 'Pet Sitters',
    seoTitle: 'Pet Sitters',
  },
  petminding: {
    id: PET_SITTING_SERVICE_ID,
    serviceName: 'House Sitting & Pet Minding',
    serviceTitle: 'House Sitting & Pet Minding',
    serviceJob: 'Pet Sitters',
    seoTitle: 'Pet Sitters',
  },
  doggydaycare: {
    id: PET_DAY_CARE_SERVICE_ID,
    serviceName: 'Pet Day Care',
    serviceTitle: 'Doggy Daycare',
    serviceJob: 'Dog Sitters',
    seoTitle: 'Dog Day Care',
  },
  housevisits: {
    id: HOUSE_VISITING_SERVICE_ID,
    serviceName: 'House Visiting',
    serviceTitle: 'House Visits',
    serviceJob: 'Pet Minders',
    seoTitle: 'Pet Minders',
  },
  dogwalkers: {
    id: DOG_WALKING_SERVICE_ID,
    serviceName: 'Dog Walking',
    serviceTitle: 'Dog Walking',
    serviceJob: 'Dog Walkers',
    seoTitle: 'Dog Walkers',
  },
  doggroomers: {
    id: DOG_GROOMING_SERVICE_ID,
    serviceName: 'Dog Grooming',
    serviceTitle: 'Dog Grooming',
    serviceJob: 'Dog Groomers',
    seoTitle: 'Dog Groomers',
  },
  dogtrainers: {
    id: DOG_TRAINING_SERVICE_ID,
    serviceName: 'Dog Training',
    serviceTitle: 'Dog Training',
    serviceJob: 'Dog Trainers',
    seoTitle: 'Dog Trainers',
  },
  'pet-groomers': {
    id: DOG_GROOMING_SERVICE_ID,
    serviceName: 'Pet Grooming',
    serviceTitle: 'Pet Grooming',
    serviceJob: 'Pet Groomers',
    seoTitle: 'Pet Groomers',
  },
  'pet-boarding': {
    id: PET_HOSTING_SERVICE_ID,
    serviceName: 'Pet Boarding',
    serviceTitle: 'Pet Boarding',
    serviceJob: 'Pet Boarders',
    seoTitle: 'Pet Boarders',
  },
  'dog-boarding': {
    id: PET_HOSTING_SERVICE_ID,
    serviceName: 'Dog Boarding',
    serviceTitle: 'Dog Boarding',
    serviceJob: 'Dog Boarders',
    seoTitle: 'Dog Boarders',
  },
  'dog-washing': {
    id: DOG_GROOMING_SERVICE_ID,
    serviceName: 'Dog Washing',
    serviceTitle: 'Dog Washing',
    serviceJob: 'Dog Washers',
    seoTitle: 'Dog Washers',
  },
  'dog-sitting': {
    id: PET_HOSTING_SERVICE_ID,
    serviceName: 'Dog Sitting',
    serviceTitle: 'Dog Sitting',
    serviceJob: 'Dog Sitters',
    seoTitle: 'Dog Sitters',
  },
  'dog-minding': {
    id: PET_HOSTING_SERVICE_ID,
    serviceName: 'Dog Minding',
    serviceTitle: 'Dog Minding',
    serviceJob: 'Dog Minders',
    seoTitle: 'Dog Minders',
  },
  'cat-boarding': {
    id: PET_SITTING_SERVICE_ID,
    serviceName: 'Cat Boarding',
    serviceTitle: 'Cat Boarding',
    serviceJob: 'Cat Boarders',
    seoTitle: 'Cat Boarders',
  },
  'cat-sitting': {
    id: HOUSE_VISITING_SERVICE_ID,
    serviceName: 'Cat Sitting',
    serviceTitle: 'Cat Sitting',
    serviceJob: 'Cat Sitters',
    seoTitle: 'Cat Sitters',
  },
  'rabbit-boarding': {
    id: HOUSE_VISITING_SERVICE_ID,
    serviceName: 'Rabbit Boarding',
    serviceTitle: 'Rabbit Boarding',
    serviceJob: 'Rabbit Boarders',
    seoTitle: 'Rabbit Boarders',
  },
  'rabbit-sitting': {
    id: HOUSE_VISITING_SERVICE_ID,
    serviceName: 'Rabbit Sitting',
    serviceTitle: 'Rabbit Sitting',
    serviceJob: 'Rabbit Sitters',
    seoTitle: 'Rabbit Sitters',
  },
  'puppy-sitting': {
    id: HOUSE_VISITING_SERVICE_ID,
    serviceName: 'Puppy Sitting',
    serviceTitle: 'Puppy Sitting',
    serviceJob: 'Puppy Sitters',
    seoTitle: 'Puppy Sitters',
  },
  'bird-sitting': {
    id: HOUSE_VISITING_SERVICE_ID,
    serviceName: 'Bird Sitting',
    serviceTitle: 'Bird Sitting',
    serviceJob: 'Bird Sitters',
    seoTitle: 'Bird Sitters',
  },
  'bird-boarding': {
    id: HOUSE_VISITING_SERVICE_ID,
    serviceName: 'Bird Boarding',
    serviceTitle: 'Bird Boarding',
    serviceJob: 'Bird Boarders',
    seoTitle: 'Bird Boarders',
  },
  'puppy-daycare': {
    id: PET_DAY_CARE_SERVICE_ID,
    serviceName: 'Puppy Daycare',
    serviceTitle: 'Puppy Daycare',
    serviceJob: 'Puppy Sitters',
    seoTitle: 'Puppy Sitters',
  },
  'dog-feeding': {
    id: PET_DAY_CARE_SERVICE_ID,
    serviceName: 'Dog Feeding',
    serviceTitle: 'Dog Feeding',
    serviceJob: 'Dog Feeders',
    seoTitle: 'Dog Feeders',
  },
  'cat-feeding': {
    id: PET_DAY_CARE_SERVICE_ID,
    serviceName: 'Cat Feeding',
    serviceTitle: 'Cat Feeding',
    serviceJob: 'Cat Feeders',
    seoTitle: 'Cat Feeders',
  },
};

export const DEFAULT_SERVICE_NAME = SERVICE_TYPE_BY_NAME_MAPPING.petsitters.serviceName;
export const DEFAULT_SERVICE_JOB = SERVICE_TYPE_BY_NAME_MAPPING.petsitters.serviceJob;
export const DEFAULT_SERVICE_TITLE = SERVICE_TYPE_BY_NAME_MAPPING.petsitters.serviceTitle;

// Sort Filters
export const SORT_FILTER_RECOMMENDED_ID = 'performance';
export const SORT_FILTER_LOCATION_ID = 'location';

export const SORT_FILTER_OPTIONS = [
  {
    label: 'Recommended',
    value: SORT_FILTER_RECOMMENDED_ID,
  },
  {
    label: 'Location',
    value: SORT_FILTER_LOCATION_ID,
  },
];

export const DEFAULT_SORT_FILTER = {
  label: 'Recommended',
  value: SORT_FILTER_RECOMMENDED_ID,
};

// Advanced Filters
export const DEFAULT_PRICE_RANGE = ['0', '300'];

export const SITTERS_HOME_OPTIONS_HOUSE_ID = 'house';
export const SITTERS_HOME_OPTIONS_APARTMENT_ID = 'apartment';
export const SITTERS_HOME_OPTIONS_FENCED_ID = 'fenced';

export const ALLOWED_SITTERS_HOME_OPTIONS = [
  SITTERS_HOME_OPTIONS_APARTMENT_ID,
  SITTERS_HOME_OPTIONS_FENCED_ID,
  SITTERS_HOME_OPTIONS_HOUSE_ID,
];

export const SITTERS_HOME_OPTIONS = [
  {
    label: 'House',
    value: SITTERS_HOME_OPTIONS_HOUSE_ID,
  },
  {
    label: 'Apartment',
    value: SITTERS_HOME_OPTIONS_APARTMENT_ID,
  },
  {
    label: 'Fenced backyard',
    value: SITTERS_HOME_OPTIONS_FENCED_ID,
  },
];

export const PETS_KIDS_AT_HOME_OPTIONS_NO_DOG_ID = 'no_dog';
export const PETS_KIDS_AT_HOME_OPTIONS_NO_CAT_ID = 'no_cat';
export const PETS_KIDS_AT_HOME_OPTIONS_NO_CHILDREN_ID = 'no_children';

export const ALLOWED_PETS_KIDS_AT_HOME_OPTIONS = [
  PETS_KIDS_AT_HOME_OPTIONS_NO_DOG_ID,
  PETS_KIDS_AT_HOME_OPTIONS_NO_CAT_ID,
  PETS_KIDS_AT_HOME_OPTIONS_NO_CHILDREN_ID,
];

export const PETS_KIDS_AT_HOME_OPTIONS = [
  {
    label: 'Doesn’t own a dog',
    value: PETS_KIDS_AT_HOME_OPTIONS_NO_DOG_ID,
  },
  {
    label: 'Doesn’t own a cat',
    value: PETS_KIDS_AT_HOME_OPTIONS_NO_CAT_ID,
  },
  {
    label: 'Doesn’t have children',
    value: PETS_KIDS_AT_HOME_OPTIONS_NO_CHILDREN_ID,
  },
];

export const ABOUT_THE_SITTER_OPTIONS_POLICY_CHECK_ID = 'police_check';
export const ABOUT_THE_SITTER_OPTIONS_FAST_RESPONSE_ID = 'fast_response';
export const ABOUT_THE_SITTER_OPTIONS_PICK_UP_ID = 'pick_up';

export const ALLOWED_ABOUT_THE_SITTER_OPTIONS = [
  ABOUT_THE_SITTER_OPTIONS_POLICY_CHECK_ID,
  ABOUT_THE_SITTER_OPTIONS_FAST_RESPONSE_ID,
  ABOUT_THE_SITTER_OPTIONS_PICK_UP_ID,
];

export const ABOUT_THE_SITTER_OPTIONS = [
  {
    label: 'Police check',
    value: ABOUT_THE_SITTER_OPTIONS_POLICY_CHECK_ID,
  },
  // TODO (WEB-1096): need to investigate the usage of this filter
  // {
  //   label: 'Fast response',
  //   value: ABOUT_THE_SITTER_OPTIONS_FAST_RESPONSE_ID,
  // },
  {
    label: 'Pick-up and drop-off',
    value: ABOUT_THE_SITTER_OPTIONS_PICK_UP_ID,
  },
];

export const SITTER_REVIEWS_ANY_ID = '0';
export const SITTER_REVIEWS_ONE_ID = '1';
export const SITTER_REVIEWS_TEN_ID = '10';

export const ALLOWED_SITTER_REVIEWS_OPTIONS = [
  SITTER_REVIEWS_ANY_ID,
  SITTER_REVIEWS_ONE_ID,
  SITTER_REVIEWS_TEN_ID,
];

export const SITTER_REVIEWS_OPTIONS = [
  {
    label: 'Any',
    value: SITTER_REVIEWS_ANY_ID,
  },
  {
    label: '1+',
    value: SITTER_REVIEWS_ONE_ID,
  },
  {
    label: '10+',
    value: SITTER_REVIEWS_TEN_ID,
  },
];

// not search related query parameters
// that should be tracked in URL as well
export const SEARCH_POSITION_QUERY_PARAMETER = 'searchPosition';
export const SEARCH_ALGORITHM_QUERY_PARAMETER = 'searchAlgorithm';

export const EXTRA_QUERY_PARAMETERS = [
  SEARCH_POSITION_QUERY_PARAMETER,
  SEARCH_ALGORITHM_QUERY_PARAMETER,
];

export const SERVICE_TYPE_DESCRIPTION_MAPPING: {
  [key: string]: string;
} = {
  petsitters:
    "Book a pet sitter to look after your pet while you're away, with all the creature comforts.",
  petminding:
    "Book a pet minder to provide personalised care for your furry friend while you're away.",
  doggydaycare:
    'Book a doggy day care session and your pet will receive personalised playtime all day long!',
  housevisits:
    'Book a pet sitter to stop by your home a few times a day to feed and play with your pet.',
  dogwalkers:
    'Book a dog walker to give them the exercise and socialisation to keep them healthy and happy.',
  doggroomers:
    'Book a dog groomer near you to keep your pet clean, trimmed and looking pooch perfect!',
  dogtrainers: 'Book a dog trainer to take your wild one from untamed to obedient in no time!',
  'pet-groomers':
    'Book a pet groomer and choose from a simple tidy-up to a full service pampering treatment.',
  'pet-boarding':
    "Book a pet sitter to offer personalised care, fun and comfort for your pet while you're away.",
  'dog-boarding':
    "Book a pet sitter who'll provide personalised care in a home environment like they're used to.",
  'dog-washing':
    'Book a Dog Groomer to take them from muddy and stinky to fresh, clean and smelling great!',
  'dog-sitting':
    "Book a dog sitter to give your pet personalised care (and lots of walkies) while you're away.",
  'dog-minding':
    "Book a pet sitter to provide your dog with tailored care for when you're not there.",
  'cat-boarding':
    "Book a pet sitter who'll provide personalised care in a home environment like they're used to.",
  'cat-sitting':
    "Book a pet sitter to look care for your cat while you're away, with all the creature comforts.",
  'rabbit-boarding':
    "Book a pet minder to provide personalised care for your rabbit while you're away.",
  'rabbit-sitting': "Book a pet sitter to feed, cuddle and care for your rabbit while you're away.",
  'puppy-sitting':
    "Book a pet sitter and give your puppy the care, playtime, and comfort they need while you're away.",
  'bird-sitting':
    "Book a pet sitter who'll provide tailored care for your bird, and regular photo updates for you!",
  'bird-boarding':
    "Book a pet sitter to give your bird the personalised care they deserve while you're away.",
  'puppy-daycare':
    'Book doggy day care for your puppy, giving them the playtime & socialisation they need to flourish.',
  'dog-feeding':
    'Book a pet sitter to stop by your home to feed your dog, top up their water, play and cuddle.',
  'cat-feeding':
    'Book a pet sitter to stop by your home to check on your cat, feed them and change their litter tray. ',
};

export const DEFAULT_SERVICE_TYPE_DESCRIPTION = SERVICE_TYPE_DESCRIPTION_MAPPING.petsitters;

export const FENCED_YARD_BADGE_ID = 2;
export const COVID_VACCINATION_ID = 33;
export const EASTER_UPSELL_BADGE_ID = 15;
export const WINTER_HOLIDAYS_BADGE_ID = 16;
export const CHRISTMAS_UPSELL_BADGE_ID = 19;
export const SPRING_UPSELL_BADGE_ID = 24;
export const POLICE_CHECK_ID = 17;
export const KINGS_BIRTHDAY_BADGE_ID = 36;

export const CALENDAR_UPDATE_THRESHOLD = 86400 * 7 * 1000;

export const BADGE_MAP: { [key: number]: BadgeIcons } = {
  17: 'shieldStar',
  2: 'fence',
  33: 'shieldCheck',
  40: 'repeatClient',
  41: 'calendarCheck',
  42: 'repeat',
};

export const defaultProfileImage =
  'https://res.cloudinary.com/madpaws/image/upload/c_fill,w_80/v1/img/no-image.png.jpg';

/* eslint-disable quotes */
export const LAST_UPDATED_FILTER_CITIES: { [key: string]: string[] } = {
  NSW: [
    'Crows Nest',
    'Waverton',
    'Surry Hills',
    'Baulkham Hills (East)',
    'Chipping Norton',
    'Moorebank',
    'Tamarama',
    'Bondi',
    'Bronte',
    'Potts Point',
    'Woolloomooloo',
    'Galston',
    'Laughtondale',
    'Maroubra',
    'South',
    'Neutral Bay',
    'Kirribilli',
    'Five Dock',
    'Abbotsford',
    'Avalon',
    'Palm Beach',
    'St Leonards',
    'Naremburn',
    'Gladesville',
    'Huntleys Point',
    'Pymble',
    'Macquarie Park',
    'Marsfield',
    'Berowra',
    'Brooklyn',
    'Cowan',
    'Chullora',
    'Balgowlah',
    'Clontarf',
    'Seaforth',
    'Baulkham Hills (West)',
    'Bella Vista',
    'Bayview',
    'Elanora Heights',
    'Guildford',
    'South Granville',
    'Macquarie Park',
    'Marsfield',
    'Casula',
    'Concord',
    'Mortlake',
    'Cabarita',
    'Condell Park',
    'Regents Park',
    'Peakhurst',
    'Lugarno',
    'Dural',
    'Kenthurst',
    'Wisemans Ferry',
    'Monterey',
    'Brighton-le-Sands',
    'Kyeemagh',
    'Ashcroft',
    'Busby',
    'Miller',
    'Sylvania',
    'Taren Point',
    'West Hoxton',
    'Middleton Grange',
    'Sutherland',
    'Kirrawee',
    'Belmore',
    'Belfield',
    'Potts Point',
    'Woolloomooloo',
    'Sans Souci',
    'Ramsgate',
    'Surry Hills',
    'Miranda',
    'Yowie Bay',
    'Sutherland',
    'Kirrawee',
    'Engadine',
    'St Marys',
    'North St Marys',
    'Happy Valley',
    'Rose Bay',
    'Vaucluse',
    'Watsons Bay',
    'Richmond',
    'Clarendon',
    'Rosemeadow',
    'Glen Alpine',
    'Kurrajong Heights',
    'Ebenezer',
    'Kurrajong Heights',
    'Ebenezer',
    'Hassall Grove',
    'Plumpton',
    'Glendenning',
    'Dean Park',
    'Mount Druitt',
    'Whalan',
    'Botany',
    'Galston',
    'Laughtondale',
    'Gladesville',
    'Huntleys Point',
    'Lawson',
    'Hazelbrook',
    'Linden',
    'Erskineville',
    'Alexandria',
    'Bankstown',
    'South',
    'Banksmeadow',
    'Paddington',
    'Moore Park',
    'Sydenham',
    'Tempe',
    'St Peters',
    'Kingsford',
    'Asquith',
    'Mount Colah',
    'Petersham',
    'Stanmore',
    'Avalon',
    'Palm Beach',
    'Turramurra',
    'Rookwood Cemetery',
    'Balgowlah',
    'Clontarf',
    'Seaforth',
    'Wentworthville',
    'Westmead',
    'Hunters Hill',
    'Woolwich',
    'Fairfield',
    'West Ryde',
    'Meadowbank',
    'Chipping Norton',
    'Moorebank',
    'Croydon Park',
    'Enfield',
    'Bossley Park',
    'Abbotsbury',
    'Pendle Hill',
    'Girraween',
    'Punchbowl',
    'Dural',
    'Kenthurst',
    'Wisemans Ferry',
    'Sylvania',
    'Taren Point',
    'Smithfield',
    'Wetherill Park',
    'Cronulla',
    'Kurnell',
    'Bundeena',
    'Cecil Hills',
    'Haberfield',
    'Summer Hill',
    'Austral',
    'Greendale',
    'Glenmore Park',
    'Regentville',
    'Revesby',
    'Penrith',
    'Sans Souci',
    'Ramsgate',
    'Lethbridge Park',
    'Tregear',
    'Caringbah South',
    'Rooty Hill',
    'Minchinbury',
    'Castle Hill',
    'Central',
    'Blaxland',
    'Warrimoo',
    'Lapstone',
    'Surry Hills',
    'Springwood',
    'Winmalee',
    'Manly',
    'Fairlight',
    'Kensington (NSW)',
    'Pennant Hills',
    'Cheltenham',
    'North Ryde',
    'East Ryde',
    'Pennant Hills',
    'Cheltenham',
    'Potts Point',
    'Woolloomooloo',
    'Bondi',
    'Tamarama',
    'Bronte',
    'Sydney Airport',
    'Maroubra',
    'South',
    'Sydenham',
    'Tempe',
    'St Peters',
    'Bradbury',
    'Wedderburn',
    'North Sydney',
    'Lavender Bay',
    'Camden',
    'Ellis Lane',
    'Turramurra',
    'Mulgoa',
    'Luddenham',
    'Orchard Hills',
    'Terrey Hills',
    'Duffys Forest',
    'Pitt Town',
    'McGraths Hill',
    'Newport',
    'Bilgola',
    'St Marys',
    'North St Marys',
    'Miranda',
    'Yowie Bay',
    'Bidwill',
    'Hebersham',
    'Emerton',
    'Berala',
    'Springwood',
    'Winmalee',
    'Toongabbie',
    'Constitution Hill',
    'Caringbah',
    'Winston Hills',
    'Auburn',
    'South',
    'Fairfield',
    'West',
    'Bondi Beach',
    'North Bondi',
    'Bonnyrigg Heights',
    'Bonnyrigg',
    'Dulwich Hill',
    'Lewisham',
    'Condell Park',
    'Asquith',
    'Mount Colah',
    'Narwee',
    'Beverly Hills',
    'Forestville',
    'Killarney Heights',
    'Cronulla',
    'Kurnell',
    'Bundeena',
    'North Ryde',
    'East Ryde',
    'Menai',
    'Lucas Heights',
    'Woronora',
    'West Pennant Hills',
    'Bankstown',
    'South',
    'Pennant Hills',
    'Cheltenham',
    'Surry Hills',
    'Concord',
    'Mortlake',
    'Cabarita',
    'West Ryde',
    'Meadowbank',
    'Auburn',
    'Central',
    'Campbelltown',
    'Woodbine',
    'Prospect Reservoir',
    'Camden',
    'Ellis Lane',
    'Dural',
    'Kenthurst',
    'Wisemans Ferry',
    'Penrith',
    'Chipping Norton',
    'Moorebank',
    'Kurrajong Heights',
    'Ebenezer',
    'Holsworthy',
    'Wattle Grove',
    'Kurrajong Heights',
    'Ebenezer',
    'Canterbury (North)',
    'Ashbury',
    'Lethbridge Park',
    'Tregear',
    'South Hurstville',
    'Blakehurst',
    'Katoomba',
    'Leura',
    'Heathcote',
    'Waterfall',
    'Surry Hills',
    'Drummoyne',
    'Rodd Point',
    'Randwick',
    'South',
    'Banksmeadow',
    'Balmain',
    'Bondi Junction',
    'Waverly',
    'Neutral Bay',
    'Kirribilli',
    'Randwick',
    'South',
    'Terrey Hills',
    'Duffys Forest',
    'West Pennant Hills',
    'Cromer',
    'Surry Hills',
    'Avalon',
    'Palm Beach',
    'Lidcombe',
    'Macquarie Park',
    'Marsfield',
    'Minto',
    'St Andrews',
    'Ashcroft',
    'Busby',
    'Miller',
    'Cambridge Park',
    'Belmore',
    'Belfield',
    'Kurrajong Heights',
    'Ebenezer',
    'Oatley',
    'Hurstville Grove',
    'Dural',
    'Kenthurst',
    'Wisemans Ferry',
    'Cronulla',
    'Kurnell',
    'Bundeena',
    'Galston',
    'Laughtondale',
    'Minto',
    'St Andrews',
    'West Pennant Hills',
    'Emu Plains',
    'Leonay',
    'Kensington (NSW)',
    'Pitt Town',
    'McGraths Hill',
    'Ermington',
    'Rydalmere',
    'Mount Druitt',
    'Whalan',
    'Granville',
    'Clyde',
    'Wentworth Falls',
    'Potts Point',
    'Woolloomooloo',
    'Banksmeadow',
    'Bondi Beach',
    'North Bondi',
    'Surry Hills',
    'Glebe',
    'Forest Lodge',
    'Glebe',
    'Forest Lodge',
    'Five Dock',
    'Abbotsford',
    'Centennial Park',
    'St Leonards',
    'Naremburn',
    'Kensington (NSW)',
    'Turramurra',
    'Balmain',
    'Freshwater',
    'Brookvale',
    'North Sydney',
    'Lavender Bay',
    'Avalon',
    'Palm Beach',
    'St Ives',
    'Oatlands',
    'Dundas Valley',
    'Freshwater',
    'Brookvale',
    'Haberfield',
    'Summer Hill',
    'Bayview',
    'Elanora Heights',
    'Lidcombe',
    'Normanhurst',
    'Thornleigh',
    'Westleigh',
    'Dural',
    'Kenthurst',
    'Wisemans Ferry',
    'Toongabbie',
    'Constitution Hill',
    'Fairfield',
    'West',
    'Guildford West',
    'Merrylands West',
    'Hoxton Park',
    'Carnes Hill',
    'Horningsea Park',
    'Cabramatta West',
    'Mount Pritchard',
    'Yagoona',
    'Birrong',
    'Balgowlah',
    'Clontarf',
    'Seaforth',
    'Revesby',
    'Newport',
    'Bilgola',
    'Sylvania',
    'Taren Point',
    'West Ryde',
    'Meadowbank',
    'Loftus',
    'Yarrawarrah',
    'West Pennant Hills',
    'Austral',
    'Greendale',
    'Homebush',
    'Bradbury',
    'Wedderburn',
    'Baulkham Hills (East)',
    'Camden',
    'Ellis Lane',
    'Chester Hill',
    'Sefton',
    'Glenmore Park',
    'Regentville',
    'Lurnea',
    'Cartwright',
    'Windsor',
    'Bligh Park',
    'Wiley Park',
    'Surry Hills',
    'Horsley Park',
    'Kemps Creek',
    'North Sydney',
    'Lavender Bay',
    'Dulwich Hill',
    'Lewisham',
    'Bondi Junction',
    'Waverly',
    'Rockdale',
    'Banksia',
    'Potts Point',
    'Woolloomooloo',
    'Menai',
    'Lucas Heights',
    'Woronora',
    'Kogarah',
    'Erskineville',
    'Alexandria',
    'Erskineville',
    'Alexandria',
    'Drummoyne',
    'Rodd Point',
    'Granville',
    'Clyde',
    'Wahroonga (East)',
    'Warrawee',
    'Bondi',
    'Tamarama',
    'Bronte',
    'Freshwater',
    'Brookvale',
    'Paddington',
    'Moore Park',
    'Bayview',
    'Elanora Heights',
    'Balmain',
    'Homebush',
    'Crows Nest',
    'Waverton',
    'Wentworthville',
    'Westmead',
    'Five Dock',
    'Abbotsford',
    'North Rocks',
    'Wahroonga (East)',
    'Warrawee',
    'Wetherill Park Industrial',
    'Putney',
    'Casula',
    'Darlinghurst',
    'Lakemba',
    'Dover Heights',
    'Caringbah',
    'Petersham',
    'Stanmore',
    'Surry Hills',
    'Crows Nest',
    'Waverton',
    'Surry Hills',
    'Normanhurst',
    'Thornleigh',
    'Westleigh',
    'Darlinghurst',
    'Hunters Hill',
    'Woolwich',
    'St Leonards',
    'Naremburn',
    'Normanhurst',
    'Thornleigh',
    'Westleigh',
    'Potts Point',
    'Woolloomooloo',
    'Ermington',
    'Rydalmere',
    'Sydney Airport',
    'Strathfield South',
    'Rose Bay',
    'Vaucluse',
    'Watsons Bay',
    'Guildford',
    'South Granville',
    'Petersham',
    'Stanmore',
    'Lalor Park',
    'Kings Langley',
    'Potts Point',
    'Woolloomooloo',
    'Glenhaven',
    'Dover Heights',
    'Ashcroft',
    'Busby',
    'Miller',
    'North Sydney',
    'Lavender Bay',
    'Homebush',
    'Chatswood (West)',
    'Lane Cove North',
    'Castle Hill',
    'North',
    'Pymble',
    'Fairfield',
    'East',
    'Berowra',
    'Brooklyn',
    'Cowan',
    'Hoxton Park',
    'Carnes Hill',
    'Horningsea Park',
    'Freshwater',
    'Brookvale',
    'Bass Hill',
    'Georges Hall',
    'Bayview',
    'Elanora Heights',
    'Chullora',
    'Bondi Junction',
    'Waverly',
    'Kogarah Bay',
    'Carlton',
    'Allawah',
    'Crows Nest',
    'Waverton',
    'Sutherland',
    'Kirrawee',
    'Lindfield',
    'Roseville',
    'Berowra',
    'Brooklyn',
    'Cowan',
    'Manly',
    'Fairlight',
    'Cremorne',
    'Cammeray',
    'Freshwater',
    'Brookvale',
    'Freshwater',
    'Brookvale',
    'Newport',
    'Bilgola',
    'Avalon',
    'Palm Beach',
    'Ermington',
    'Rydalmere',
    'Gladesville',
    'Huntleys Point',
    'Cherrybrook',
    'Toongabbie',
    'Constitution Hill',
    'Toongabbie',
    'Constitution Hill',
    'Fairfield',
    'East',
    'Baulkham Hills (West)',
    'Bella Vista',
    'Greenfield Park',
    'Prairiewood',
    'Chester Hill',
    'Sefton',
    'Sans Souci',
    'Ramsgate',
    'Galston',
    'Laughtondale',
    'Gymea',
    'Grays Point',
    'Horsley Park',
    'Kemps Creek',
    'Menai',
    'Lucas Heights',
    'Woronora',
    'Bankstown',
    'North',
    'Narwee',
    'Beverly Hills',
    'Edensor Park',
    'Sans Souci',
    'Ramsgate',
    'Yagoona',
    'Birrong',
    'Lilli Pilli',
    'Port Hacking',
    'Dolans Bay',
    'Kingsgrove (South)',
    'Bardwell Park',
    'Pagewood',
    'Hillsdale',
    'Daceyville',
    'Lilli Pilli',
    'Port Hacking',
    'Dolans Bay',
    'Drummoyne',
    'Rodd Point',
    'Menai',
    'Lucas Heights',
    'Woronora',
    'Potts Point',
    'Woolloomooloo',
    'Hornsby',
    'East',
    'Potts Point',
    'Woolloomooloo',
    'Manly',
    'Fairlight',
    'Lilyfield',
    'Rozelle',
    'Hunters Hill',
    'Woolwich',
    'Kensington (NSW)',
    'Oatlands',
    'Dundas Valley',
    'Crows Nest',
    'Waverton',
    'Blacktown (East)',
    'Kings Park',
    'Gordon',
    'Killara',
    'Dural',
    'Kenthurst',
    'Wisemans Ferry',
    'Manly',
    'Fairlight',
    'Guildford West',
    'Merrylands West',
    'Bayview',
    'Elanora Heights',
    'West Hoxton',
    'Middleton Grange',
    'North Ryde',
    'East Ryde',
    'South Hurstville',
    'Blakehurst',
    'Lalor Park',
    'Kings Langley',
    'Gymea',
    'Grays Point',
    'Canley Vale',
    'Canley Heights',
    'Riverwood',
    'Wahroonga (East)',
    'Warrawee',
    'Kogarah',
    'Freshwater',
    'Brookvale',
    'Oyster Bay',
    'Como',
    'Jannali',
    'Bayview',
    'Elanora Heights',
    'Sutherland',
    'Kirrawee',
    'Croydon Park',
    'Enfield',
    'Woollahra',
    'Granville',
    'Clyde',
    'Crows Nest',
    'Waverton',
    'Dural',
    'Kenthurst',
    'Wisemans Ferry',
    'Erskineville',
    'Alexandria',
    'Cabramatta',
    'Lansvale',
    'Rose Bay',
    'Vaucluse',
    'Watsons Bay',
    'Greenfield Park',
    'Prairiewood',
    'Lindfield',
    'Roseville',
    'Bankstown',
    'South',
    'Five Dock',
    'Abbotsford',
    'Bossley Park',
    'Abbotsbury',
    'St Leonards',
    'Naremburn',
    'Roselands',
    'St Ives',
    'Kingsgrove (South)',
    'Bardwell Park',
    'Bayview',
    'Elanora Heights',
    'Gymea',
    'Grays Point',
    'Gordon',
    'Killara',
    'Illawong',
    'Alfords Point',
    'Freshwater',
    'Brookvale',
    'Haberfield',
    'Summer Hill',
    'Beacon Hill',
    'Narraweena',
    'North Sydney',
    'Lavender Bay',
    'Avalon',
    'Palm Beach',
    'Gordon',
    'Killara',
    'Oatlands',
    'Dundas Valley',
    'Berowra',
    'Brooklyn',
    'Cowan',
    'Lidcombe',
    'Balgowlah',
    'Clontarf',
    'Seaforth',
    'Chester Hill',
    'Sefton',
    'Manly Vale',
    'Allambie Heights',
    'Hinchinbrook',
    'Bayview',
    'Elanora Heights',
    'Bass Hill',
    'Georges Hall',
    'Ermington',
    'Rydalmere',
    'Cremorne',
    'Cammeray',
    'Croydon Park',
    'Enfield',
    'Bayview',
    'Elanora Heights',
    'Regents Park',
    'Avalon',
    'Palm Beach',
    'Dural',
    'Kenthurst',
    'Wisemans Ferry',
    'North Ryde',
    'East Ryde',
    'Canley Vale',
    'Canley Heights',
    'Sans Souci',
    'Ramsgate',
    'Hinchinbrook',
    'Lilli Pilli',
    'Port Hacking',
    'Dolans Bay',
    'Kogarah Bay',
    'Carlton',
    'Allawah',
    'Blacktown (East)',
    'Kings Park',
    'Oyster Bay',
    'Como',
    'Jannali',
    'Galston',
    'Laughtondale',
    'Oyster Bay',
    'Como',
    'Jannali',
    'Lurnea',
    'Cartwright',
    'Monterey',
    'Brighton-le-Sands',
    'Kyeemagh',
    'Holsworthy',
    'Wattle Grove',
    'Oyster Bay',
    'Como',
    'Jannali',
    'Lakemba',
    'Illawong',
    'Alfords Point',
    'Newport',
    'Bilgola',
    'Berowra',
    'Brooklyn',
    'Cowan',
    'Granville',
    'Clyde',
    'Randwick',
    'North',
    'Prospect Reservoir',
    'Lilyfield',
    'Rozelle',
    'Dural',
    'Kenthurst',
    'Wisemans Ferry',
    'North Sydney',
    'Lavender Bay',
    'Fairfield',
    'East',
    'Bondi Junction',
    'Waverly',
    'Warwick Farm',
    'Pagewood',
    'Hillsdale',
    'Daceyville',
    'Bonnyrigg Heights',
    'Bonnyrigg',
    'Crows Nest',
    'Waverton',
    'Bankstown',
    'South',
    'Chatswood (West)',
    'Lane Cove North',
    'Rockdale',
    'Banksia',
    'Asquith',
    'Mount Colah',
    'Sylvania',
    'Taren Point',
    'Sydenham',
    'Tempe',
    'St Peters',
    'Peakhurst',
    'Lugarno',
    'Asquith',
    'Mount Colah',
    'Monterey',
    'Brighton-le-Sands',
    'Kyeemagh',
    'Neutral Bay',
    'Kirribilli',
    'South Hurstville',
    'Blakehurst',
    'Terrey Hills',
    'Duffys Forest',
    'Woolaware',
    'Burraneer',
    'Cromer',
    'West Pennant Hills',
    'Newport',
    'Bilgola',
    'Surry Hills',
    'Gladesville',
    'Huntleys Point',
    'Hornsby',
    'East',
    'Wentworthville',
    'Westmead',
    'Fairfield',
    'Galston',
    'Laughtondale',
    'Woollahra',
    'Ashcroft',
    'Busby',
    'Miller',
    'Chatswood (West)',
    'Lane Cove North',
    'Condell Park',
    'North Parramatta',
    'Forestville',
    'Killarney Heights',
    'Bondi Beach',
    'North Bondi',
    'Bayview',
    'Elanora Heights',
    'Smithfield',
    'Wetherill Park',
    'Gladesville',
    'Huntleys Point',
    'Darlinghurst',
    'Padstow',
    'Botany',
    'South Hurstville',
    'Blakehurst',
    'Port Botany Industrial',
    'Loftus',
    'Yarrawarrah',
    'North Sydney',
    'Lavender Bay',
    'Pendle Hill',
    'Girraween',
    'Lindfield',
    'Roseville',
    'Yennora Industrial',
    'Galston',
    'Laughtondale',
    'St Johns Park',
    'Wakeley',
    'Neutral Bay',
    'Kirribilli',
    'Manly Vale',
    'Allambie Heights',
    'Bayview',
    'Elanora Heights',
    'Hunters Hill',
    'Woolwich',
    'Macquarie Park',
    'Marsfield',
    'Pennant Hills',
    'Cheltenham',
    'Lalor Park',
    'Kings Langley',
    'Concord',
    'Mortlake',
    'Cabarita',
    'Cabramatta',
    'Lansvale',
    'Auburn',
    'Central',
    'Bondi Junction',
    'Waverly',
    'Smithfield',
    'Wetherill Park',
    'Pagewood',
    'Hillsdale',
    'Daceyville',
    'Ashcroft',
    'Busby',
    'Miller',
    'Cremorne',
    'Cammeray',
    'Holsworthy',
    'Wattle Grove',
    'Horsley Park',
    'Kemps Creek',
    'Canterbury (North)',
    'Ashbury',
    'Woronora Heights',
    'Kingsgrove (South)',
    'Bardwell Park',
    'Berowra',
    'Brooklyn',
    'Cowan',
    'Caringbah',
    'Bayview',
    'Elanora Heights',
    'Menai',
    'Lucas Heights',
    'Woronora',
    'Homebush',
    'Peakhurst',
    'Lugarno',
    'Dural',
    'Kenthurst',
    'Wisemans Ferry',
    'Monterey',
    'Brighton-le-Sands',
    'Kyeemagh',
    'Bass Hill',
    'Georges Hall',
    'Oyster Bay',
    'Como',
    'Jannali',
    'St Johns Park',
    'Wakeley',
    'Heathcote',
    'Waterfall',
    'Padstow',
    'Hornsby',
    'East',
    'Kogarah Bay',
    'Carlton',
    'Allawah',
    'Surry Hills',
    'Miranda',
    'Yowie Bay',
    'Rose Bay',
    'Vaucluse',
    'Watsons Bay',
    'Five Dock',
    'Abbotsford',
    'Castle Hill',
    'North',
    'St Ives',
    'Bondi Junction',
    'Waverly',
    'Manly Vale',
    'Allambie Heights',
    'Pagewood',
    'Hillsdale',
    'Daceyville',
    'Bayview',
    'Elanora Heights',
    'Drummoyne',
    'Rodd Point',
    'Gladesville',
    'Huntleys Point',
    'North Sydney',
    'Lavender Bay',
    'North Parramatta',
    'Turramurra',
    'Smithfield',
    'Wetherill Park',
    'Avalon',
    'Palm Beach',
    'Hinchinbrook',
    'Pennant Hills',
    'Cheltenham',
    'Holsworthy',
    'Wattle Grove',
    'Concord',
    'Mortlake',
    'Cabarita',
    'Canterbury (North)',
    'Ashbury',
    'Toongabbie',
    'Constitution Hill',
    'Revesby',
    'Blacktown (North)',
    'Marayong',
    'Sylvania',
    'Taren Point',
    'Galston',
    'Laughtondale',
    'Menai',
    'Lucas Heights',
    'Woronora',
    'Holsworthy',
    'Wattle Grove',
    'Claymore',
    'Eagle Vale',
    'Raby',
    'Rose Bay',
    'Vaucluse',
    'Watsons Bay',
    'Rosemeadow',
    'Glen Alpine',
    'Petersham',
    'Stanmore',
    'Camden',
    'Ellis Lane',
    'Lindfield',
    'Roseville',
    'Cambridge Park',
    'Woolaware',
    'Burraneer',
    'Jamisontown',
    'South Penrith',
    'Waitara',
    'Wahroonga (West)',
    'Windsor',
    'Bligh Park',
    'Beacon Hill',
    'Narraweena',
    'Glenwood',
    'Bayview',
    'Elanora Heights',
    'Dural',
    'Kenthurst',
    'Wisemans Ferry',
    'Gladesville',
    'Huntleys Point',
    'Kingswood',
    'Werrington',
    'Guildford',
    'South Granville',
    'Richmond',
    'Clarendon',
    'Northmead',
    'Kurrajong Heights',
    'Ebenezer',
    'Guildford West',
    'Merrylands West',
    'Glendenning',
    'Dean Park',
    'Green Valley',
    'Bidwill',
    'Hebersham',
    'Emerton',
    'Holsworthy',
    'Wattle Grove',
    'Dural',
    'Kenthurst',
    'Wisemans Ferry',
    'Bankstown',
    'South',
    'Springwood',
    'Winmalee',
    'Peakhurst',
    'Lugarno',
    'Campbelltown',
    'Woodbine',
    'Rockdale',
    'Banksia',
    'Campbelltown',
    'Woodbine',
    'South Hurstville',
    'Blakehurst',
    'Minto',
    'St Andrews',
    'Cronulla',
    'Kurnell',
    'Bundeena',
    'Kingswood',
    'Werrington',
    'Sydenham',
    'Tempe',
    'St Peters',
    'Kurrajong Heights',
    'Ebenezer',
    'Neutral Bay',
    'Kirribilli',
    'Glendenning',
    'Dean Park',
    'Lindfield',
    'Roseville',
    'Bidwill',
    'Hebersham',
    'Emerton',
    'Berowra',
    'Brooklyn',
    'Cowan',
    'Mulgoa',
    'Luddenham',
    'Orchard Hills',
    'Cremorne',
    'Cammeray',
    'Yarramundi',
    'Londonderry',
    'Manly Vale',
    'Allambie Heights',
    'Pitt Town',
    'McGraths Hill',
    'Bayview',
    'Elanora Heights',
    'Hassall Grove',
    'Plumpton',
    'Ermington',
    'Rydalmere',
    'Lethbridge Park',
    'Tregear',
    'Croydon Park',
    'Enfield',
    'Austral',
    'Greendale',
    'Yagoona',
    'Birrong',
    'Emu Plains',
    'Leonay',
    'Blacktown (East)',
    'Kings Park',
    'Windsor',
    'Bligh Park',
    'Dural',
    'Kenthurst',
    'Wisemans Ferry',
    'Colyton',
    'Oxley Park',
    'Cabramatta West',
    'Mount Pritchard',
    'Pitt Town',
    'McGraths Hill',
    'Hoxton Park',
    'Carnes Hill',
    'Horningsea Park',
    'Bidwill',
    'Hebersham',
    'Emerton',
    'Horsley Park',
    'Kemps Creek',
    'Lawson',
    'Hazelbrook',
    'Linden',
    'Kogarah Bay',
    'Carlton',
    'Allawah',
    'Rosemeadow',
    'Glen Alpine',
    'Oyster Bay',
    'Como',
    'Jannali',
    'Claymore',
    'Eagle Vale',
    'Raby',
    'Leumeah',
    'Minto Heights',
    'Leumeah',
    'Minto Heights',
    'Rosemeadow',
    'Glen Alpine',
    'Leumeah',
    'Minto Heights',
    'Claymore',
    'Eagle Vale',
    'Raby',
    'Kurrajong Heights',
    'Ebenezer',
    'Bradbury',
    'Wedderburn',
    'St Clair',
    'Yarramundi',
    'Londonderry',
    'Rooty Hill',
    'Minchinbury',
    'Pitt Town',
    'McGraths Hill',
    'Galston',
    'Laughtondale',
    'Blaxland',
    'Warrimoo',
    'Lapstone',
    'Cambridge Park',
    'Emu Plains',
    'Leonay',
    'Dural',
    'Kenthurst',
    'Wisemans Ferry',
    'Kurrajong Heights',
    'Ebenezer',
    'Quakers Hill',
    'Springwood',
    'Winmalee',
    'Bidwill',
    'Hebersham',
    'Emerton',
    'Kingswood',
    'Werrington',
    'Springwood',
    'Winmalee',
    'Richmond',
    'Clarendon',
    'Kingswood',
    'Werrington',
    'Kurrajong Heights',
    'Ebenezer',
    'Warragamba',
    'Silverdale',
    'Acacia Gardens',
    'Kurrajong Heights',
    'Ebenezer',
    'Prospect Reservoir',
    'St Marys',
    'North St Marys',
    'Rosemeadow',
    'Glen Alpine',
    'Doonside',
    'Woodcroft',
    'Claymore',
    'Eagle Vale',
    'Raby',
    'Springwood',
    'Winmalee',
    'Claymore',
    'Eagle Vale',
    'Raby',
    'Claymore',
    'Eagle Vale',
    'Raby',
    'Richmond',
    'Clarendon',
    'Bradbury',
    'Wedderburn',
    'Pitt Town',
    'McGraths Hill',
    'Camden',
    'Ellis Lane',
    'Mount Druitt',
    'Whalan',
    'Richmond',
    'Clarendon',
    'Lawson',
    'Hazelbrook',
    'Linden',
    'Kurrajong Heights',
    'Ebenezer',
    'Kurrajong Heights',
    'Ebenezer',
    'Kurrajong Heights',
    'Ebenezer',
    'Dural',
    'Kenthurst',
    'Wisemans Ferry',
    'Lethbridge Park',
    'Tregear',
    'Erskine Park',
    'Katoomba',
    'Leura',
    'Lethbridge Park',
    'Tregear',
    'Mulgoa',
    'Luddenham',
    'Orchard Hills',
    'Lawson',
    'Hazelbrook',
    'Linden',
    'Warragamba',
    'Silverdale',
    'Jamisontown',
    'South Penrith',
    'Blaxland',
    'Warrimoo',
    'Lapstone',
    'Pitt Town',
    'McGraths Hill',
    'Penrith',
    'Blaxland',
    'Warrimoo',
    'Lapstone',
    'Richmond',
    'Clarendon',
    'Katoomba',
    'Leura',
    'Blaxland',
    'Warrimoo',
    'Lapstone',
    'Claymore',
    'Eagle Vale',
    'Raby',
    'Katoomba',
    'Leura',
    'Campbelltown',
    'Woodbine',
    'Minto',
    'St Andrews',
    'Camden',
    'Ellis Lane',
    'Badgerys Creek',
    'Jamisontown',
    'South Penrith',
    'Windsor',
    'Bligh Park',
    'St Marys',
    'North St Marys',
    'Rooty Hill',
    'Minchinbury',
    'Katoomba',
    'Leura',
    'Richmond',
    'Clarendon',
    'Kurrajong Heights',
    'Ebenezer',
    'Hassall Grove',
    'Plumpton',
    'Blaxland',
    'Warrimoo',
    'Lapstone',
    'Lawson',
    'Hazelbrook',
    'Linden',
    'Campbelltown',
    'Woodbine',
    'Camden',
    'Ellis Lane',
    'Badgerys Creek',
    'Leumeah',
    'Minto Heights',
    'Rosemeadow',
    'Glen Alpine',
    'Cambridge Park',
    'Richmond',
    'Clarendon',
    'Doonside',
    'Woodcroft',
    'Dural',
    'Kenthurst',
    'Wisemans Ferry',
    'Colyton',
    'Oxley Park',
    'Yarramundi',
    'Londonderry',
    'Kurrajong Heights',
    'Ebenezer',
    'Dural',
    'Kenthurst',
    'Wisemans Ferry',
    'St Marys',
    'North St Marys',
    'Springwood',
    'Winmalee',
    'Baulkham Hills',
    'East',
    'Baulkham Hills',
    'Bella Vista',
    'Glenhaven',
    'West Pennant Hills',
    'Castle Hill',
    'Central',
    'Castle Hill',
    'East',
    'Castle Hill',
    'North',
    'Castle Hill',
    'South',
    'Castle Hill',
    'West',
    'Cherrybrook',
    'Kellyville',
    'East',
    'Kellyville',
    'West',
    'Dural',
    'Kenthurst',
    'Wisemans Ferry',
    'Galston',
    'Laughtondale',
    'Kurrajong Heights',
    'Ebenezer',
    'Pitt Town',
    'McGraths Hill',
    'Box Hill',
    'Nelson',
    'North Kellyville',
    'Rouse Hill',
    'Beaumont Hills',
    'Blacktown',
    'Kings Park',
    'Blacktown',
    'Marayong',
    'Doonside',
    'Woodcroft',
    'Lalor Park',
    'Kings Langley',
    'Blacktown',
    'South',
    'Blacktown',
    'West',
    'Seven Hills',
    'Prospect',
    'Toongabbie',
    'West',
    'Glenwood',
    'Acacia Gardens',
    'Quakers Hill',
    'Kellyville Ridge',
    'The Ponds',
    'Marsden Park',
    'Shanes Park',
    'Riverstone',
    'Schofields',
    'Colebee',
    'Schofields',
    'East',
    'Stanhope Gardens',
    'Parklea',
    'Bidwill',
    'Hebersham',
    'Emerton',
    'Glendenning',
    'Dean Park',
    'Hassall Grove',
    'Plumpton',
    'Lethbridge Park',
    'Tregear',
    'Mount Druitt',
    'Whalan',
    'Prospect Reservoir',
    'Rooty Hill',
    'Minchinbury',
    'Banksmeadow',
    'Botany',
    'Pagewood',
    'Hillsdale',
    'Daceyville',
    'Port Botany Industrial',
    'Sydney Airport',
    'Eastlakes',
    'Mascot',
    'Petersham',
    'Stanmore',
    'Sydenham',
    'Tempe',
    'St Peters',
    'Marrickville',
    'North',
    'Marrickville',
    'South',
    'Darlinghurst',
    'Erskineville',
    'Alexandria',
    'Glebe',
    'Forest Lodge',
    'Potts Point',
    'Woolloomooloo',
    'Surry Hills',
    'Camperdown',
    'Darlington',
    'Chippendale',
    'Newtown',
    'Pyrmont',
    'Redfern',
    'Rosebery',
    'Beaconsfield',
    'Sydney',
    'Millers Point',
    'Haymarket',
    'Elizabeth Bay',
    'Ultimo',
    'Waterloo',
    'Zetland',
    'Bondi',
    'Tamarama',
    'Bronte',
    'Bondi Beach',
    'North Bondi',
    'Bondi Junction',
    'Waverly',
    'Centennial Park',
    'Dover Heights',
    'Paddington',
    'Moore Park',
    'Rose Bay',
    'Vaucluse',
    'Watsons Bay',
    'Woollahra',
    'Bellevue Hill',
    'Double Bay',
    'Darling Point',
    'Kensington',
    'Kingsford',
    'Maroubra',
    'North',
    'Maroubra',
    'South',
    'Maroubra',
    'West',
    'Randwick',
    'North',
    'Randwick',
    'South',
    'Coogee',
    'Clovelly',
    'Malabar',
    'La Perouse',
    'Matraville',
    'Chifley',
    'South Coogee',
    'Rushcutters Bay',
    'Bass Hill',
    'Georges Hall',
    'Chullora',
    'Condell Park',
    'Padstow',
    'Revesby',
    'Revesby Heights',
    'Yagoona',
    'Birrong',
    'Bankstown',
    'North',
    'Bankstown',
    'South',
    'Greenacre',
    'North',
    'Greenacre',
    'South',
    'Panania',
    'Milperra',
    'Panania',
    'Picnic Point',
    'Belmore',
    'Belfield',
    'Punchbowl',
    'Roselands',
    'Lakemba',
    'Wiley Park',
    'Campsie',
    'North',
    'Campsie',
    'South',
    'Canterbury',
    'South',
    'Earlwood',
    'Kingsgrove',
    'North',
    'Narwee',
    'Beverly Hills',
    'Oatley',
    'Hurstville Grove',
    'Peakhurst',
    'Lugarno',
    'Riverwood',
    'South Hurstville',
    'Blakehurst',
    'Hurstville',
    'Central',
    'Hurstville',
    'North',
    'Mortdale',
    'Oatley',
    'Penshurst',
    'Kingsgrove',
    'Bardwell Park',
    'Kogarah',
    'Kogarah Bay',
    'Carlton',
    'Allawah',
    'Monterey',
    'Brighton',
    'le',
    'Sands',
    'Kyeemagh',
    'Rockdale',
    'Banksia',
    'Sans Souci',
    'Ramsgate',
    'Arncliffe',
    'Bardwell Valley',
    'Bexley',
    'North',
    'Bexley',
    'South',
    'Wolli Creek',
    'Concord',
    'Mortlake',
    'Cabarita',
    'Drummoyne',
    'Rodd Point',
    'Five Dock',
    'Abbotsford',
    'Concord West',
    'North Strathfield',
    'Rhodes',
    'Balmain',
    'Lilyfield',
    'Rozelle',
    'Annandale',
    'Leichhardt',
    'Canterbury',
    'Ashbury',
    'Croydon Park',
    'Enfield',
    'Dulwich Hill',
    'Lewisham',
    'Haberfield',
    'Summer Hill',
    'Homebush',
    'Strathfield South',
    'Ashfield',
    'North',
    'Ashfield',
    'South',
    'Burwood',
    'Croydon',
    'Strathfield',
    'Edgecliff',
    'Strathfield',
    'Chatswood',
    'Lane Cove North',
    'St Leonards',
    'Naremburn',
    'Artarmon',
    'Castle Cove',
    'Northbridge',
    'Chatswood',
    'East',
    'Greenwich',
    'Riverview',
    'Lane Cove',
    'Willoughby',
    'Asquith',
    'Mount Colah',
    'Berowra',
    'Brooklyn',
    'Cowan',
    'Normanhurst',
    'Thornleigh',
    'Westleigh',
    'Hornsby',
    'East',
    'Hornsby',
    'West',
    'Wahroonga',
    'Waitara',
    'Gordon',
    'Killara',
    'Lindfield',
    'Roseville',
    'Pymble',
    'St Ives',
    'Turramurra',
    'Wahroonga',
    'Warrawee',
    'Cremorne',
    'Cammeray',
    'Crows Nest',
    'Waverton',
    'Neutral Bay',
    'Kirribilli',
    'North Sydney',
    'Lavender Bay',
    'Mosman',
    'North',
    'Mosman',
    'South',
    'Balgowlah',
    'Clontarf',
    'Seaforth',
    'Manly',
    'Fairlight',
    'Avalon',
    'Palm Beach',
    'Bayview',
    'Elanora Heights',
    'Newport',
    'Bilgola',
    'Mona Vale',
    'Warriewood',
    'North Narrabeen',
    'Warriewood',
    'Beacon Hill',
    'Narraweena',
    'Cromer',
    'Forestville',
    'Killarney Heights',
    'Freshwater',
    'Brookvale',
    'Manly Vale',
    'Allambie Heights',
    'Terrey Hills',
    'Duffys Forest',
    'Belrose',
    'Collaroy',
    'Collaroy Plateau',
    'Dee Why',
    'North Curl Curl',
    'Dee Why',
    'North',
    'Frenchs Forest',
    'Oxford Falls',
    'Narrabeen',
    'Wheeler Heights',
    'Camden',
    'Ellis Lane',
    'Currans Hill',
    'Elderslie',
    'Narellan',
    'Harrington Park',
    'Mount Annan',
    'Spring Farm',
    'Bradbury',
    'Wedderburn',
    'Campbelltown',
    'Woodbine',
    'Claymore',
    'Eagle Vale',
    'Raby',
    'Leumeah',
    'Minto Heights',
    'Minto',
    'St Andrews',
    'Rosemeadow',
    'Glen Alpine',
    'Denham Court',
    'Bardia',
    'Glenfield',
    'Ingleburn',
    'Macquarie Fields',
    'Blaxland',
    'Warrimoo',
    'Lapstone',
    'Katoomba',
    'Leura',
    'Lawson',
    'Hazelbrook',
    'Linden',
    'Springwood',
    'Winmalee',
    'Wentworth Falls',
    'Cambridge Park',
    'Emu Plains',
    'Leonay',
    'Glenmore Park',
    'Regentville',
    'Jamisontown',
    'South Penrith',
    'Kingswood',
    'Werrington',
    'Mulgoa',
    'Luddenham',
    'Orchard Hills',
    'Penrith',
    'Warragamba',
    'Silverdale',
    'Cranebrook',
    'Castlereagh',
    'Jordan Springs',
    'Llandilo',
    'Richmond',
    'Clarendon',
    'Windsor',
    'Bligh Park',
    'Yarramundi',
    'Londonderry',
    'Erskine Park',
    'St Clair',
    'Colyton',
    'Oxley Park',
    'St Marys',
    'North St Marys',
    'Rookwood Cemetery',
    'Auburn',
    'Central',
    'Auburn',
    'North',
    'Auburn',
    'South',
    'Berala',
    'Lidcombe',
    'Regents Park',
    'Silverwater',
    'Newington',
    'Wentworth Point',
    'Sydney Olympic Park',
    'Ermington',
    'Rydalmere',
    'Oatlands',
    'Dundas Valley',
    'Carlingford',
    'East',
    'Carlingford',
    'West',
    'Chester Hill',
    'Sefton',
    'Fairfield',
    'East',
    'Granville',
    'Clyde',
    'Guildford',
    'South Granville',
    'Guildford West',
    'Merrylands West',
    'Smithfield Industrial',
    'Yennora Industrial',
    'Greystanes',
    'South',
    'Merrylands',
    'Holroyd',
    'Pemulwuy',
    'Greystanes',
    'South Wentworthville',
    'North Parramatta',
    'North Rocks',
    'Northmead',
    'Toongabbie',
    'Constitution Hill',
    'Winston Hills',
    'Pendle Hill',
    'Girraween',
    'Wentworthville',
    'Westmead',
    'Parramatta',
    'North',
    'Parramatta',
    'South',
    'Rosehill',
    'Harris Park',
    'Pennant Hills',
    'Cheltenham',
    'Epping',
    'North Epping',
    'Epping',
    'West',
    'Gladesville',
    'Huntleys Point',
    'Hunters Hill',
    'Woolwich',
    'Macquarie Park',
    'Marsfield',
    'North Ryde',
    'East Ryde',
    'West Ryde',
    'Meadowbank',
    'Putney',
    'Denistone',
    'Eastwood',
    'Ryde',
    'North',
    'Ryde',
    'South',
    'Ashcroft',
    'Busby',
    'Miller',
    'Austral',
    'Greendale',
    'Badgerys Creek',
    'Cecil Hills',
    'Green Valley',
    'Hinchinbrook',
    'Hoxton Park',
    'Carnes Hill',
    'Horningsea Park',
    'West Hoxton',
    'Middleton Grange',
    'Cobbitty',
    'Bringelly',
    'Gledswood Hills',
    'Gregory Hills',
    'Leppington',
    'Catherine Field',
    'Oran Park',
    'Bonnyrigg Heights',
    'Bonnyrigg',
    'Bossley Park',
    'Abbotsbury',
    'Cabramatta',
    'Lansvale',
    'Cabramatta West',
    'Mount Pritchard',
    'Canley Vale',
    'Canley Heights',
    'Edensor Park',
    'Fairfield',
    'Fairfield',
    'West',
    'Greenfield Park',
    'Prairiewood',
    'Horsley Park',
    'Kemps Creek',
    'Smithfield',
    'Wetherill Park',
    'St Johns Park',
    'Wakeley',
    'Wetherill Park Industrial',
    'Casula',
    'Chipping Norton',
    'Moorebank',
    'Holsworthy',
    'Wattle Grove',
    'Lurnea',
    'Cartwright',
    'Warwick Farm',
    'Edmondson Park',
    'Liverpool',
    'East',
    'Liverpool',
    'West',
    'Prestons',
    'Gymea',
    'Grays Point',
    'Miranda',
    'Yowie Bay',
    'Sylvania',
    'Taren Point',
    'Caringbah',
    'Caringbah South',
    'Cronulla',
    'Kurnell',
    'Bundeena',
    'Lilli Pilli',
    'Port Hacking',
    'Dolans Bay',
    'Woolooware',
    'Burraneer',
    'Heathcote',
    'Waterfall',
    'Illawong',
    'Alfords Point',
    'Menai',
    'Lucas Heights',
    'Woronora',
    'Oyster Bay',
    'Como',
    'Jannali',
    'Sutherland',
    'Kirrawee',
    'Engadine',
    'Loftus',
    'Yarrawarrah',
    'Woronora Heights',
    'DARLINGHURST',
    'POTTS POINT',
    'KINGS CROSS',
    'WOOLLAHRA',
    'BONDI JUNCTION',
    'ALEXANDRIA',
    'BOTANY',
    'KENSINGTON',
    'UNSW SYDNEY',
    'DRUMMOYNE',
    'KOGARAH',
    'MIRANDA',
    'CARINGBAH',
    'SUTHERLAND',
    'WEST CHATSWOOD',
    'MILSONS POINT',
    'CROWS NEST',
    'ST LEONARDS',
    'HORNSBY',
    'HORNSBY WESTFIELD',
    'MANLY',
    'NORTH RYDE',
    'NORTH RYDE BC',
    'GLADESVILLE',
    'WEST RYDE',
    'ERMINGTON',
    'PENNANT HILLS',
    'NORTH PARRAMATTA',
    'BAULKHAM HILLS',
    'CASTLE HILL',
    'ST MARYS',
    'LIDCOMBE',
    'AUBURN',
    'WETHERILL PARK',
    'FAIRFIELD',
    'MOOREBANK',
    'BANKSTOWN',
    'BARANGAROO',
    'DAWES POINT',
    'HAYMARKET',
    'MILLERS POINT',
    'PARLIAMENT HOUSE',
    'SYDNEY',
    'SYDNEY SOUTH',
    'THE ROCKS',
    'EASTERN SUBURBS MC',
    'BROADWAY',
    'ULTIMO',
    'CHIPPENDALE',
    'DARLINGTON',
    'PYRMONT',
    'DARLINGHURST',
    'SURRY HILLS',
    'ELIZABETH BAY',
    'POTTS POINT',
    'RUSHCUTTERS BAY',
    'WOOLLOOMOOLOO',
    'STRAWBERRY HILLS',
    'ALEXANDRIA',
    'BEACONSFIELD',
    'EVELEIGH',
    'REDFERN',
    'WATERLOO',
    'WATERLOO DC',
    'ZETLAND',
    'EASTLAKES',
    'ROSEBERY',
    'BANKSMEADOW',
    'BOTANY',
    'MASCOT',
    'SYDNEY DOMESTIC AIRPORT',
    'SYDNEY INTERNATIONAL AIRPORT',
    'CENTENNIAL PARK',
    'MOORE PARK',
    'PADDINGTON',
    'BONDI JUNCTION',
    'QUEENS PARK',
    'BELLEVUE HILL',
    'BRONTE',
    'WAVERLEY',
    'WOOLLAHRA',
    'BONDI',
    'BONDI BEACH',
    'NORTH BONDI',
    'TAMARAMA',
    'DARLING POINT',
    'EDGECLIFF',
    'HMAS RUSHCUTTERS',
    'POINT PIPER',
    'ROSE BAY',
    'DOVER HEIGHTS',
    'HMAS WATSON',
    'ROSE BAY NORTH',
    'VAUCLUSE',
    'WATSONS BAY',
    'CLOVELLY',
    'CLOVELLY WEST',
    'RANDWICK',
    'RANDWICK DC',
    'ST PAULS',
    'DACEYVILLE',
    'KINGSFORD',
    'KENSINGTON',
    'COOGEE',
    'SOUTH COOGEE',
    'MAROUBRA',
    'MAROUBRA SOUTH',
    'PAGEWOOD',
    'CHIFLEY',
    'EASTGARDENS',
    'HILLSDALE',
    'LA PEROUSE',
    'LITTLE BAY',
    'MALABAR',
    'MATRAVILLE',
    'PHILLIP BAY',
    'PORT BOTANY',
    'FOREST LODGE',
    'GLEBE',
    'ANNANDALE',
    'ROZELLE',
    'LEICHHARDT',
    'LILYFIELD',
    'BALMAIN',
    'BALMAIN EAST',
    'BIRCHGROVE',
    'ENMORE',
    'NEWTOWN',
    'ERSKINEVILLE',
    'ST PETERS',
    'ST PETERS DC',
    'SYDENHAM',
    'TEMPE',
    'HABERFIELD',
    'ABBOTSFORD',
    'CANADA BAY',
    'CHISWICK',
    'FIVE DOCK',
    'RODD POINT',
    'RUSSELL LEA',
    'WAREEMBA',
    'DRUMMOYNE',
    'STANMORE',
    'WESTGATE',
    'LEWISHAM',
    'PETERSHAM',
    'PETERSHAM NORTH',
    'CAMPERDOWN',
    'MISSENDEN ROAD',
    'UNSW SYDNEY',
    'NORTH SYDNEY',
    'NORTH SYDNEY',
    'HMAS PLATYPUS',
    'HMAS WATERHEN',
    'LAVENDER BAY',
    'MCMAHONS POINT',
    'NORTH SYDNEY',
    'NORTH SYDNEY SHOPPINGWORLD',
    'WAVERTON',
    'KIRRIBILLI',
    'MILSONS POINT',
    'CAMMERAY',
    'ARTARMON',
    'CROWS NEST',
    'CROWS NEST DC',
    'GREENWICH',
    'NAREMBURN',
    'ROYAL NORTH SHORE HOSPITAL',
    'ST LEONARDS',
    'WOLLSTONECRAFT',
    'LANE COVE',
    'LANE COVE DC',
    'LANE COVE NORTH',
    'LANE COVE WEST',
    'LINLEY POINT',
    'LONGUEVILLE',
    'NORTHWOOD',
    'RIVERVIEW',
    'CHATSWOOD',
    'CHATSWOOD WEST',
    'CASTLECRAG',
    'MIDDLE COVE',
    'NORTH WILLOUGHBY',
    'WILLOUGHBY',
    'WILLOUGHBY EAST',
    'WILLOUGHBY NORTH',
    'CASTLE COVE',
    'ROSEVILLE',
    'ROSEVILLE CHASE',
    'EAST LINDFIELD',
    'LINDFIELD',
    'LINDFIELD WEST',
    'EAST KILLARA',
    'KILLARA',
    'GORDON',
    'PYMBLE',
    'WEST PYMBLE',
    'NORTH TURRAMURRA',
    'SOUTH TURRAMURRA',
    'TURRAMURRA',
    'WARRAWEE',
    'ST IVES',
    'ST IVES CHASE',
    'NORMANHURST',
    'NORTH WAHROONGA',
    'WAHROONGA',
    'ASQUITH',
    'HORNSBY',
    'HORNSBY HEIGHTS',
    'WAITARA',
    'MOUNT COLAH',
    'MOUNT KURING-GAI',
    'BEROWRA',
    'COWAN',
    'BEROWRA CREEK',
    'BEROWRA HEIGHTS',
    'BEROWRA WATERS',
    'BAR POINT',
    'BROOKLYN',
    'CHEERO POINT',
    'COGRA BAY',
    'DANGAR ISLAND',
    'MILSONS PASSAGE',
    'MOONEY MOONEY',
    'COTTAGE POINT',
    'DUFFYS FOREST',
    'TERREY HILLS',
    'BELROSE',
    'BELROSE WEST',
    'DAVIDSON',
    'FRENCHS FOREST',
    'FRENCHS FOREST EAST',
    'FORESTVILLE',
    'KILLARNEY HEIGHTS',
    'MOSMAN',
    'SPIT JUNCTION',
    'KURRABA POINT',
    'NEUTRAL BAY',
    'NEUTRAL BAY JUNCTION',
    'CREMORNE',
    'CREMORNE JUNCTION',
    'CREMORNE POINT',
    'SEAFORTH',
    'BALGOWLAH',
    'BALGOWLAH HEIGHTS',
    'CLONTARF',
    'MANLY VALE',
    'NORTH BALGOWLAH',
    'FAIRLIGHT',
    'MANLY',
    'MANLY EAST',
    'CURL CURL',
    'FRESHWATER',
    'QUEENSCLIFF',
    'COLLAROY',
    'COLLAROY BEACH',
    'COLLAROY PLATEAU',
    'WHEELER HEIGHTS',
    'CROMER',
    'DEE WHY',
    'NARRAWEENA',
    'NORTH CURL CURL',
    'ALLAMBIE HEIGHTS',
    'BEACON HILL',
    'BROOKVALE',
    'NORTH MANLY',
    'OXFORD FALLS',
    'WARRINGAH MALL',
    'ELANORA HEIGHTS',
    'INGLESIDE',
    'NARRABEEN',
    'NORTH NARRABEEN',
    'MONA VALE',
    'BAYVIEW',
    'CHURCH POINT',
    'ELVINA BAY',
    'LOVETT BAY',
    'MCCARRS CREEK',
    'MORNING BAY',
    'SCOTLAND ISLAND',
    'NEWPORT',
    'NEWPORT BEACH',
    'AVALON BEACH',
    'BILGOLA BEACH',
    'BILGOLA PLATEAU',
    'CLAREVILLE',
    'WHALE BEACH',
    'COASTERS RETREAT',
    'CURRAWONG BEACH',
    'GREAT MACKEREL BEACH',
    'PALM BEACH',
    'MACQUARIE UNIVERSITY',
    'HUNTERS HILL',
    'WOOLWICH',
    'GLADESVILLE',
    'HENLEY',
    'HUNTLEYS COVE',
    'HUNTLEYS POINT',
    'MONASH PARK',
    'TENNYSON POINT',
    'DENISTONE EAST',
    'PUTNEY',
    'RYDE',
    'BLENHEIM ROAD',
    'EAST RYDE',
    'MACQUARIE CENTRE',
    'MACQUARIE PARK',
    'NORTH RYDE',
    'DENISTONE',
    'DENISTONE WEST',
    'MEADOWBANK',
    'MELROSE PARK',
    'WEST RYDE',
    'ERMINGTON',
    'RYDALMERE',
    'DUNDAS',
    'DUNDAS VALLEY',
    'OATLANDS',
    'TELOPEA',
    'CARLINGFORD',
    'CARLINGFORD COURT',
    'CARLINGFORD NORTH',
    'KINGSDENE',
    'BEECROFT',
    'CHELTENHAM',
    'PENNANT HILLS',
    'THORNLEIGH',
    'WESTLEIGH',
    'EPPING',
    'NORTH EPPING',
    'EASTWOOD',
    'MARSFIELD',
    'WEST PENNANT HILLS',
    'CHERRYBROOK',
    'NEWINGTON',
    'SYDNEY OLYMPIC PARK',
    'WENTWORTH POINT',
    'SYDNEY MARKETS',
    'SUMMER HILL',
    'ASHFIELD',
    'CROYDON',
    'CROYDON PARK',
    'ENFIELD SOUTH',
    'BURWOOD',
    'BURWOOD NORTH',
    'STRATHFIELD',
    'BURWOOD HEIGHTS',
    'ENFIELD',
    'STRATHFIELD SOUTH',
    'BREAKFAST POINT',
    'CABARITA',
    'CONCORD',
    'MORTLAKE',
    'NORTH STRATHFIELD',
    'CONCORD WEST',
    'CONCORD WEST DC',
    'LIBERTY GROVE',
    'RHODES',
    'HOMEBUSH',
    'HOMEBUSH SOUTH',
    'HOMEBUSH WEST',
    'BERALA',
    'LIDCOMBE',
    'LIDCOMBE NORTH',
    'ROOKWOOD',
    'BLAXCELL',
    'CAMELLIA',
    'CLYDE',
    'GRANVILLE',
    'HOLROYD',
    'ROSEHILL',
    'SOUTH GRANVILLE',
    'BIRRONG',
    'POTTS HILL',
    'REGENTS PARK',
    'REGENTS PARK DC',
    'AUBURN',
    'CONSTITUTION HILL',
    'GIRRAWEEN',
    'GREYSTANES',
    'MAYS HILL',
    'PEMULWUY',
    'PENDLE HILL',
    'SOUTH WENTWORTHVILLE',
    'WENTWORTHVILLE',
    'WESTMEAD',
    'OLD TOONGABBIE',
    'TOONGABBIE',
    'TOONGABBIE EAST',
    'KINGS LANGLEY',
    'LALOR PARK',
    'SEVEN HILLS',
    'SEVEN HILLS WEST',
    'ARNDELL PARK',
    'BLACKTOWN',
    'BLACKTOWN WESTPOINT',
    'HUNTINGWOOD',
    'KINGS PARK',
    'MARAYONG',
    'PROSPECT',
    'HARRIS PARK',
    'PARRAMATTA',
    'PARRAMATTA WESTFIELD',
    'NORTH PARRAMATTA',
    'NORTH ROCKS',
    'NORTHMEAD',
    'BAULKHAM HILLS',
    'BELLA VISTA',
    'NORWEST',
    'WINSTON HILLS',
    'CASTLE HILL',
    'BEAUMONT HILLS',
    'KELLYVILLE',
    'KELLYVILLE RIDGE',
    'NORTH KELLYVILLE',
    'ROUSE HILL',
    'ANNANGROVE',
    'GLENHAVEN',
    'KENTHURST',
    'CANOELANDS',
    'FOREST GLEN',
    'GLENORIE',
    'DURAL',
    'DURAL DC',
    'MIDDLE DURAL',
    'ROUND CORNER',
    'ARCADIA',
    'BERRILEE',
    'FIDDLETOWN',
    'GALSTON',
    'MERRYLANDS',
    'MERRYLANDS WEST',
    'GUILDFORD',
    'GUILDFORD WEST',
    'OLD GUILDFORD',
    'YENNORA',
    'CHESTER HILL',
    'SEFTON',
    'CARRAMAR',
    'LANSDOWNE',
    'VILLAWOOD',
    'SMITHFIELD',
    'SMITHFIELD WEST',
    'WETHERILL PARK',
    'WETHERILL PARK BC',
    'WOODPARK',
    'FAIRFIELD',
    'FAIRFIELD EAST',
    'FAIRFIELD HEIGHTS',
    'FAIRFIELD WEST',
    'CABRAMATTA',
    'CABRAMATTA WEST',
    'CANLEY HEIGHTS',
    'CANLEY VALE',
    'LANSVALE',
    'GLENFIELD',
    'ASHCROFT',
    'BUSBY',
    'CARTWRIGHT',
    'GREEN VALLEY',
    'HECKENBERG',
    'HINCHINBROOK',
    'MILLER',
    'SADLEIR',
    'CASULA',
    'CASULA MALL',
    'CHIPPING NORTON',
    'HAMMONDVILLE',
    'LIVERPOOL',
    'LIVERPOOL SOUTH',
    'LIVERPOOL WESTFIELD',
    'LURNEA',
    'MOOREBANK',
    'MOUNT PRITCHARD',
    'PRESTONS',
    'WARWICK FARM',
    'CARNES HILL',
    'CECIL HILLS',
    'ELIZABETH HILLS',
    'HORNINGSEA PARK',
    'HOXTON PARK',
    'LEN WATERS ESTATE',
    'MIDDLETON GRANGE',
    'WEST HOXTON',
    'PLEASURE POINT',
    'SANDY POINT',
    'VOYAGER POINT',
    'HOLSWORTHY',
    'WATTLE GROVE',
    'EDMONDSON PARK',
    'HORSLEY PARK',
    'ABBOTSBURY',
    'BOSSLEY PARK',
    'EDENSOR PARK',
    'GREENFIELD PARK',
    'PRAIRIEWOOD',
    'ST JOHNS PARK',
    'WAKELEY',
    'BONNYRIGG',
    'BONNYRIGG HEIGHTS',
    'CECIL PARK',
    'KEMPS CREEK',
    'MOUNT VERNON',
    'AUSTRAL',
    'LEPPINGTON',
    'CHULLORA',
    'GREENACRE',
    'MOUNT LEWIS',
    'BELFIELD',
    'BELMORE',
    'ASHBURY',
    'CANTERBURY',
    'HURLSTONE PARK',
    'CAMPSIE',
    'LAKEMBA',
    'LAKEMBA DC',
    'WILEY PARK',
    'PUNCHBOWL',
    'ROSELANDS',
    'BASS HILL',
    'GEORGES HALL',
    'YAGOONA',
    'YAGOONA WEST',
    'BANKSTOWN',
    'BANKSTOWN AERODROME',
    'BANKSTOWN NORTH',
    'BANKSTOWN SQUARE',
    'CONDELL PARK',
    'MANAHAN',
    'MOUNT LEWIS',
    'DULWICH HILL',
    'MARRICKVILLE',
    'MARRICKVILLE METRO',
    'MARRICKVILLE SOUTH',
    'ARNCLIFFE',
    'TURRELLA',
    'WOLLI CREEK',
    'CLEMTON PARK',
    'EARLWOOD',
    'BARDWELL PARK',
    'BARDWELL VALLEY',
    'BEXLEY',
    'BEXLEY NORTH',
    'BEXLEY SOUTH',
    'KINGSGROVE',
    'KINGSGROVE DC',
    'KINGSWAY WEST',
    'BEVERLY HILLS',
    'NARWEE',
    'LUGARNO',
    'PEAKHURST',
    'PEAKHURST DC',
    'PEAKHURST HEIGHTS',
    'RIVERWOOD',
    'PADSTOW',
    'PADSTOW HEIGHTS',
    'REVESBY',
    'REVESBY HEIGHTS',
    'REVESBY NORTH',
    'EAST HILLS',
    'PANANIA',
    'PICNIC POINT',
    'BANKSIA',
    'BRIGHTON-LE-SANDS',
    'KYEEMAGH',
    'ROCKDALE',
    'ROCKDALE DC',
    'BEVERLEY PARK',
    'KOGARAH',
    'KOGARAH BAY',
    'MONTEREY',
    'RAMSGATE',
    'RAMSGATE BEACH',
    'ALLAWAH',
    'CARLTON',
    'DOLLS POINT',
    'SANDRINGHAM',
    'SANS SOUCI',
    'HURSTVILLE',
    'HURSTVILLE GROVE',
    'HURSTVILLE WESTFIELD',
    'BLAKEHURST',
    'CARSS PARK',
    'CONNELLS POINT',
    'KYLE BAY',
    'SOUTH HURSTVILLE',
    'PENSHURST',
    'MORTDALE',
    'OATLEY',
    'KANGAROO POINT',
    'SYLVANIA',
    'SYLVANIA SOUTHGATE',
    'SYLVANIA WATERS',
    'OYSTER BAY',
    'BONNET BAY',
    'COMO',
    'JANNALI',
    'GYMEA',
    'GYMEA BAY',
    'MIRANDA',
    'YOWIE BAY',
    'CARINGBAH',
    'CARINGBAH SOUTH',
    'DOLANS BAY',
    'LILLI PILLI',
    'PORT HACKING',
    'TAREN POINT',
    'BUNDEENA',
    'BURRANEER',
    'CRONULLA',
    'GREENHILLS BEACH',
    'MAIANBAR',
    'WOOLOOWARE',
    'KURNELL',
    'GRAYS POINT',
    'KAREELA',
    'KIRRAWEE',
    'KIRRAWEE DC',
    'LOFTUS',
    'ROYAL NATIONAL PARK',
    'SUTHERLAND',
    'WORONORA',
    'ENGADINE',
    'HEATHCOTE',
    'WATERFALL',
    'WORONORA HEIGHTS',
    'YARRAWARRAH',
    'ALFORDS POINT',
    'BANGOR',
    'BARDEN RIDGE',
    'ILLAWONG',
    'LUCAS HEIGHTS',
    'MENAI',
    'MENAI CENTRAL',
    'BIRMINGHAM GARDENS',
    'ELERMORE VALE',
    'FLETCHER',
    'MARYLAND',
    'MINMI',
    'RANKIN PARK',
    'WALLSEND',
    'WALLSEND DC',
    'WALLSEND SOUTH',
    'DANGAR',
    'BINIGUY',
    'PALLAMALLAWA',
    'BADGERYS CREEK',
    'CATHERINE FIELD',
    'GLEDSWOOD HILLS',
    'GREGORY HILLS',
    'ROSSMORE',
    'EAGLE VALE',
    'ESCHOL PARK',
    'KEARNS',
    'BLAIRMOUNT',
    'CLAYMORE',
    'AIRDS',
    'AMBARVALE',
    'APPIN',
    'BLAIR ATHOL',
    'BRADBURY',
    'CAMPBELLTOWN',
    'CAMPBELLTOWN NORTH',
    'CATARACT',
    'ENGLORIE PARK',
    'GILEAD',
    'GLEN ALPINE',
    'KENTLYN',
    'LEUMEAH',
    'MACARTHUR SQUARE',
    'ROSEMEADOW',
    'RUSE',
    'ST HELENS PARK',
    'WEDDERBURN',
    'WOODBINE',
    'MENANGLE PARK',
    'GLENQUARIE',
    'LONG POINT',
    'MACQUARIE FIELDS',
    'BARDIA',
    'DENHAM COURT',
    'INGLEBURN',
    'MACQUARIE LINKS',
    'BOW BOWING',
    'MINTO',
    'MINTO HEIGHTS',
    'RABY',
    'ST ANDREWS',
    'VARROVILLE',
    'CURRANS HILL',
    'HARRINGTON PARK',
    'MOUNT ANNAN',
    'NARELLAN',
    'NARELLAN VALE',
    'SMEATON GRANGE',
    'BELIMBLA PARK',
    'BICKLEY VALE',
    'BROWNLOW HILL',
    'CAMDEN',
    'CAMDEN PARK',
    'CAMDEN SOUTH',
    'CAWDOR',
    'COBBITTY',
    'ELDERSLIE',
    'ELLIS LANE',
    'GLENMORE',
    'GRASMERE',
    'KIRKHAM',
    'MOUNT HUNTER',
    'NATTAI',
    'OAKDALE',
    'ORAN PARK',
    'ORANGEVILLE',
    'SPRING FARM',
    'THE OAKS',
    'THERESA PARK',
    'WEROMBI',
    'GLENMORE PARK',
    'GREENDALE',
    'LUDDENHAM',
    'MULGOA',
    'REGENTVILLE',
    'WALLACIA',
    'CADDENS',
    'CAMBRIDGE GARDENS',
    'CAMBRIDGE PARK',
    'CLAREMONT MEADOWS',
    'JORDAN SPRINGS',
    'KINGSWOOD',
    'LLANDILO',
    'SHANE PARK',
    'SHANES PARK',
    'WERRINGTON',
    'WERRINGTON COUNTY',
    'WERRINGTON DOWNS',
    'ORCHARD HILLS',
    'CASTLEREAGH',
    'CRANEBROOK',
    'EMU HEIGHTS',
    'EMU PLAINS',
    'JAMISONTOWN',
    'LEONAY',
    'PENRITH',
    'PENRITH PLAZA',
    'PENRITH SOUTH',
    'SOUTH PENRITH',
    'PENRITH',
    'SILVERDALE',
    'WARRAGAMBA',
    'AGNES BANKS',
    'BOWEN MOUNTAIN',
    'GROSE VALE',
    'GROSE WOLD',
    'HOBARTVILLE',
    'LONDONDERRY',
    'RICHMOND',
    'RICHMOND LOWLANDS',
    'YARRAMUNDI',
    'NORTH RICHMOND',
    'TENNYSON',
    'THE SLOPES',
    'BLIGH PARK',
    'CATTAI',
    'CENTRAL COLO',
    'CLARENDON',
    'COLO',
    'COLO HEIGHTS',
    'CORNWALLIS',
    'CUMBERLAND REACH',
    'EBENEZER',
    'FREEMANS REACH',
    'GLOSSODIA',
    'LOWER PORTLAND',
    'MAROOTA',
    'MCGRATHS HILL',
    'MELLONG',
    'MULGRAVE',
    'PITT TOWN',
    'PITT TOWN BOTTOMS',
    'SACKVILLE',
    'SACKVILLE NORTH',
    'SCHEYVILLE',
    'SOUTH MAROOTA',
    'SOUTH WINDSOR',
    'UPPER COLO',
    'WILBERFORCE',
    'WINDSOR',
    'WINDSOR DOWNS',
    'WOMERAH',
    'KURMOND',
    'BERAMBING',
    'BILPIN',
    'BLAXLANDS RIDGE',
    'EAST KURRAJONG',
    'KURRAJONG',
    'KURRAJONG HEIGHTS',
    'KURRAJONG HILLS',
    'MOUNT TOMAH',
    'MOUNTAIN LAGOON',
    'THE DEVILS WILDERNESS',
    'WHEENY CREEK',
    'ERSKINE PARK',
    'ST CLAIR',
    'COLYTON',
    'NORTH ST MARYS',
    'OXLEY PARK',
    'ROPES CROSSING',
    'ST MARYS',
    'ST MARYS EAST',
    'ST MARYS SOUTH',
    'COLEBEE',
    'DEAN PARK',
    'GLENDENNING',
    'HASSALL GROVE',
    'OAKHURST',
    'PLUMPTON',
    'SCHOFIELDS',
    'TALLAWONG',
    'ACACIA GARDENS',
    'NIRIMBA FIELDS',
    'QUAKERS HILL',
    'ANGUS',
    'BERKSHIRE PARK',
    'BOX HILL',
    'GABLES',
    'GRANTHAM FARM',
    'MARAYLYA',
    'MARSDEN PARK',
    'MELONBA',
    'NELSON',
    'OAKVILLE',
    'RICHARDS',
    'RIVERSTONE',
    'VINEYARD',
    'EASTERN CREEK',
    'ROOTY HILL',
    'BUNGARRIBEE',
    'DOONSIDE',
    'WOODCROFT',
    'GLENWOOD',
    'PARKLEA',
    'STANHOPE GARDENS',
    'THE PONDS',
    'BIDWILL',
    'BLACKETT',
    'DHARRUK',
    'EMERTON',
    'HEBERSHAM',
    'LETHBRIDGE PARK',
    'MINCHINBURY',
    'MOUNT DRUITT',
    'MOUNT DRUITT VILLAGE',
    'SHALVEY',
    'TREGEAR',
    'WHALAN',
    'WILLMOT',
    'GLENBROOK',
    'LAPSTONE',
    'BLAXLAND',
    'BLAXLAND EAST',
    'MOUNT RIVERVIEW',
    'WARRIMOO',
    'CENTRAL MACDONALD',
    'FERNANCES',
    'GUNDERMAN',
    'HIGHER MACDONALD',
    'LAUGHTONDALE',
    'LEETS VALE',
    'LOWER MACDONALD',
    'MARLOW',
    'MOGO CREEK',
    'PERRYS CROSSING',
    'SINGLETONS MILL',
    'SPENCER',
    'ST ALBANS',
    'UPPER MACDONALD',
    'WEBBS CREEK',
    'WISEMANS FERRY',
    'WRIGHTS CREEK',
    'FAULCONBRIDGE',
    'HAWKESBURY HEIGHTS',
    'SPRINGWOOD',
    'SUN VALLEY',
    'VALLEY HEIGHTS',
    'WINMALEE',
    'YELLOW ROCK',
    'LINDEN',
    'WOODFORD',
    'HAZELBROOK',
    'KATOOMBA',
    'KATOOMBA DC',
    'LEURA',
    'MEDLOW BATH',
    'WENTWORTH FALLS',
    'LAWSON',
    'BULLABURRA',
    'ARNOLD',
    'ARNOLD WEST',
    'ASCOT',
    'AXE CREEK',
    'AXEDALE',
    'BAGSHOT',
    'BAGSHOT NORTH',
    'BENDIGO FORWARD',
    'CORNELLA',
    'CREEK VIEW',
    'EMU CREEK',
    'EPPALOCK',
    'EPSOM',
    'HUNTLY',
    'HUNTLY NORTH',
    'JUNORTOUN',
    'KIMBOLTON',
    'LAKE EPPALOCK',
    'LLANELLY',
    'LOCKWOOD',
    'LOCKWOOD SOUTH',
    'LONGLEA',
    'MAIDEN GULLY',
    'MANDURANG',
    'MANDURANG SOUTH',
    'MURPHYS CREEK',
    'MYOLA',
    'MYRTLE CREEK',
    'NEWBRIDGE',
    'PAINSWICK',
    'SEDGWICK',
    'STRATHFIELDSAYE',
    'TARNAGULLA',
    'TOOLLEEN',
    'WAANYARRA',
    'WELLSFORD',
    'WOODSTOCK ON LODDON',
  ],
  Q: [
    'Brisbane City',
    'Eagle Farm',
    'Pinkenba',
    'Albion',
    'Clontarf',
    'Rothwell',
    'Kippa-Ring',
    'Wooloowin',
    'Lutwyche',
    'Chermside',
    'Keperra',
    'Stafford',
    'Paddington',
    'Milton',
    'Paddington',
    'Milton',
    'Pinjarra Hills',
    'Pullenvale',
    'Riverhills',
    'Sunnybank',
    'Rocklea',
    'Acacia Ridge',
    'Browns Plains',
    'Woodridge',
    'Coorparoo',
    'Upper Mount Gravatt',
    'Redland Bay',
    'Waterford West',
    'Wolffdene',
    'Bahrs Scrub',
    'Bulimba',
    'Hamilton (Qld)',
    'Newstead',
    'Bowen Hills',
    'Northgate',
    'Virginia',
    'Northgate',
    'Virginia',
    'Kelvin Grove',
    'Herston',
    'Redcliffe',
    'Enoggera',
    'Albany Creek',
    'Red Hill (Qld)',
    'Kedron',
    'Gordon Park',
    'Fig Tree Pocket',
    'St Lucia',
    'Inala',
    'Richlands',
    'Westlake',
    'Woolloongabba',
    'Yeronga',
    'Rocklea',
    'Acacia Ridge',
    'Salisbury',
    'Nathan',
    'Greenslopes',
    'Mansfield (Qld)',
    'Shailer Park',
    'Cornubia',
    'Carbrook',
    'Rochedale',
    'Burbank',
    'Belmont',
    'Gumdale',
    'Wynnum',
    'Tingalpa',
    'Wolffdene',
    'Bahrs Scrub',
    'Beenleigh',
    'Brisbane City',
    'Brisbane City',
    'Brisbane Airport',
    'Kelvin Grove',
    'Herston',
    'Brighton (Qld)',
    'Northgate',
    'Virginia',
    'Stafford',
    'Taigum',
    'Fitzgibbon',
    'St Lucia',
    'Enoggera',
    'Middle Park',
    'Jamboree Heights',
    'Kelvin Grove',
    'Herston',
    'Fairfield',
    'Dutton Park',
    'Brookfield',
    'Kenmore Hills',
    'Browns Plains',
    'Inala',
    'Richlands',
    'Springwood',
    'Sunnybank Hills',
    'Chambers Flat',
    'Logan Reserve',
    'Mansfield (Qld)',
    'Thornlands',
    'Loganholme',
    'Tanah Merah',
    'Wynnum West',
    'Hemmant',
    'Capalaba',
    'Mount Warren Park',
    'Fortitude Valley',
    'Brisbane City',
    'Sandgate',
    'Shorncliffe',
    'Clayfield',
    'Boondall',
    'Kedron',
    'Gordon Park',
    'Stafford',
    'Eatons Hill',
    'Toowong',
    'Paddington',
    'Milton',
    'Bellbowrie',
    'Moggill',
    'Indooroopilly',
    'Darra',
    'Sumner',
    'Wacol',
    'Rocklea',
    'Acacia Ridge',
    'Fairfield',
    'Dutton Park',
    'Kingston (Qld.)',
    'Rocklea',
    'Acacia Ridge',
    'Regents Park',
    'Heritage Park',
    'Parkinson',
    'Drewvale',
    'Carina',
    'Holland Park West',
    'Ormiston',
    'Loganholme',
    'Tanah Merah',
    'Balmoral',
    'Capalaba',
    'Logan Village',
    'Victoria Point',
    'Ascot',
    'Brisbane City',
    'Sandgate',
    'Shorncliffe',
    'Nudgee',
    'Banyo',
    'Carseldine',
    'Chermside',
    'The Hills District',
    'McDowall',
    'Toowong',
    'Bardon',
    'Seventeen Mile Rocks',
    'Sinnamon Park',
    'Chapel Hill',
    'West End',
    'Durack',
    'Salisbury',
    'Nathan',
    'Moorooka',
    'Brisbane City',
    'Brisbane City',
    'Brisbane Airport',
    'Newstead',
    'Bowen Hills',
    'Bracken Ridge',
    'Nundah',
    'Redcliffe',
    'Sandgate',
    'Shorncliffe',
    'Mitchelton',
    'Alderley',
    'Bardon',
    'Upper Kedron',
    'Ferny Grove',
    'Pinjarra Hills',
    'Pullenvale',
    'Kenmore',
    'South Brisbane',
    'Wacol',
    'Logan Central',
    'Coopers Plains',
    'Boronia Heights',
    'Park Ridge',
    'Holland Park',
    'Cornubia',
    'Carbrook',
    'Springwood',
    'Wellington Point',
    'Rochedale',
    'Burbank',
    'Brisbane Port',
    'Lytton',
    'Norman Park',
    'Newstead',
    'Bowen Hills',
    'Hamilton (Qld)',
    'Wavell Heights',
    'Clontarf',
    'Margate',
    'Woody Point',
    'Wooloowin',
    'Lutwyche',
    'Chermside West',
    'The Hills District',
    'The Hills District',
    'Ashgrove',
    'Auchenflower',
    'Pinjarra Hills',
    'Pullenvale',
    'Seventeen Mile Rocks',
    'Sinnamon Park',
    'Durack',
    'Moorooka',
    'Annerley',
    'Salisbury',
    'Nathan',
    'Pallara',
    'Willawong',
    'Tarragindi',
    'Greenslopes',
    'Loganholme',
    'Tanah Merah',
    'Runcorn',
    'Camp Hill',
    'Browns Plains',
    'Woodridge',
    'Rochedale',
    'Burbank',
    'Hillcrest',
    'Crestmead',
    'Carindale',
    'Thorneside',
    'Cleveland',
    'Morningside',
    'Seven Hills',
    'Hawthorne',
    'Eagleby',
    'Sheldon',
    'Mount Cotton',
    'Loganlea',
    'Manly West',
    'Thornlands',
    'Leichhardt',
    'One Mile',
    'Wynnum',
    'Beaudesert',
    'Carole Park',
    'Beaudesert',
    'Leichhardt',
    'One Mile',
    'Albion',
    'Rosewood',
    'Clontarf',
    'Beaudesert',
    'Geebung',
    'Spring Hill',
    'Upper Kedron',
    'Ferny Grove',
    'Hendra',
    'Chelmer',
    'Graceville',
    'Chermside',
    'Middle Park',
    'Jamboree Heights',
    'Newmarket',
    'West End',
    'Bardon',
    'Rocklea',
    'Acacia Ridge',
    'Brookfield',
    'Kenmore Hills',
    'Brisbane City',
    'Durack',
    'Eagle Farm',
    'Pinkenba',
    'Yeronga',
    'Brighton (Qld)',
    'Newstead',
    'Bowen Hills',
    'Rothwell',
    'Kippa-Ring',
    'Nundah',
    'Stafford Heights',
    'Brighton (Qld)',
    'Toowong',
    'Bridgeman Downs',
    'Bellbowrie',
    'Moggill',
    'Keperra',
    'Woolloongabba',
    'Taringa',
    'Woodridge',
    'Darra',
    'Sumner',
    'Boronia Heights',
    'Park Ridge',
    'Rocklea',
    'Acacia Ridge',
    'Loganlea',
    'Tarragindi',
    'Alexandra Hills',
    'Slacks Creek',
    'Wynnum',
    'Belmont',
    'Gumdale',
    'Brisbane City',
    'Victoria Point',
    'Albion',
    'Ascot',
    'Aspley',
    'Taigum',
    'Fitzgibbon',
    'Kelvin Grove',
    'Herston',
    'Windsor',
    'Paddington',
    'Milton',
    'Everton Park',
    'Darra',
    'Sumner',
    'The Gap',
    'Highgate Hill',
    'Fig Tree Pocket',
    'Salisbury',
    'Nathan',
    'Macgregor (Qld)',
    'Algester',
    'Logan Central',
    'Upper Mount Gravatt',
    'Greenbank Military Camp',
    'Parkinson',
    'Drewvale',
    'Coorparoo',
    'Underwood',
    'Rocklea',
    'Acacia Ridge',
    'Munruben',
    'Park Ridge South',
    'Calamvale',
    'Stretton',
    'Wakerley',
    'Rochedale South',
    'Priestdale',
    'Cleveland',
    'Cornubia',
    'Carbrook',
    'Tingalpa',
    'Sheldon',
    'Mount Cotton',
    'Coorparoo',
    'East Brisbane',
    'Tingalpa',
    'Bethania',
    'Waterford',
    'Beaudesert',
    'Murarrie',
    'Ipswich',
    'East',
    'Wolffdene',
    'Bahrs Scrub',
    'Beaudesert',
    'Beaudesert',
    'Spring Hill',
    'Ipswich',
    'East',
    'Wavell Heights',
    'Rosewood',
    'Albany Creek',
    'Brisbane Airport',
    'Kelvin Grove',
    'Herston',
    'Margate',
    'Woody Point',
    'Brisbane City',
    'Windsor',
    'Northgate',
    'Virginia',
    'Mitchelton',
    'Chermside West',
    'Ashgrove',
    'Mitchelton',
    'Brisbane City',
    'Mount Coot-tha',
    'Albion',
    'Brookfield',
    'Kenmore Hills',
    'Zillmere',
    'Inala',
    'Richlands',
    'Red Hill (Qld)',
    'Yeronga',
    'Indooroopilly',
    'Runcorn',
    'Oxley (Qld)',
    'Hillcrest',
    'Fairfield',
    'Dutton Park',
    'Rochedale South',
    'Priestdale',
    'Robertson',
    'Chambers Flat',
    'Logan Reserve',
    'Calamvale',
    'Stretton',
    'Cleveland',
    'Greenslopes',
    'Morningside',
    'Seven Hills',
    'Rochedale South',
    'Priestdale',
    'Edens Landing',
    'Holmview',
    'Capalaba',
    'Fortitude Valley',
    'Victoria Point',
    'Northgate',
    'Virginia',
    'Manly',
    'Lota',
    'Grange',
    'Brisbane City',
    'Ashgrove',
    'Eagle Farm',
    'Pinkenba',
    'St Lucia',
    'Clontarf',
    'Corinda',
    'Kedron',
    'Gordon Park',
    'Rocklea',
    'Acacia Ridge',
    'The Hills District',
    'Kuraby',
    'Bardon',
    'Mount Gravatt',
    'Bellbowrie',
    'Moggill',
    'Paddington',
    'Milton',
    'Woolloongabba',
    'Chelmer',
    'Graceville',
    'Pallara',
    'Willawong',
    'South Brisbane',
    'Mount Gravatt',
    'Sunnybank',
    'Munruben',
    'Park Ridge South',
    'Calamvale',
    'Stretton',
    'Jindalee',
    'Mount Ommaney',
    'Springwood',
    'Inala',
    'Richlands',
    'Carina Heights',
    'Greenslopes',
    'East Brisbane',
    'Pallara',
    'Willawong',
    'Wolffdene',
    'Bahrs Scrub',
    'Holland Park',
    'Crestmead',
    'Marsden',
    'East Brisbane',
    'Belmont',
    'Gumdale',
    'Wynnum West',
    'Hemmant',
    'Wynnum West',
    'Hemmant',
    'Beaudesert',
    'Logan Village',
    'Ipswich',
    'East',
    'Belmont',
    'Gumdale',
    'Ipswich',
    'North',
    'Wynnum West',
    'Hemmant',
    'Karalee',
    'Barellan Point',
    'Beaudesert',
    'Ripley',
    'Springfield Lakes',
    'New Farm',
    'North Ipswich',
    'Tivoli',
    'Brisbane Airport',
    'Ripley',
    'Deagon',
    'Brisbane City',
    'Wooloowin',
    'Lutwyche',
    'Newstead',
    'Bowen Hills',
    'Stafford Heights',
    'Nudgee',
    'Banyo',
    'Indooroopilly',
    'Margate',
    'Woody Point',
    'Darra',
    'Sumner',
    'Grange',
    'Annerley',
    'Red Hill (Qld)',
    'Regents Park',
    'Heritage Park',
    'Brookfield',
    'Kenmore Hills',
    'Daisy Hill',
    'South Brisbane',
    'Camp Hill',
    'Logan Central',
    'Redland Bay',
    'Mount Gravatt',
    'Brisbane City',
    'Shailer Park',
    'Eagle Farm',
    'Pinkenba',
    'Birkdale',
    'Kedron',
    'Gordon Park',
    'Murarrie',
    'Stafford',
    'Hamilton (Qld)',
    'Ashgrove',
    'Nudgee',
    'Banyo',
    'Jindalee',
    'Mount Ommaney',
    'Bald Hills',
    'Inala',
    'Richlands',
    'Kelvin Grove',
    'Herston',
    'Yeronga',
    'Bardon',
    'Pallara',
    'Willawong',
    'Sherwood',
    'Brisbane City',
    'South Brisbane',
    'Clayfield',
    'Sunnybank Hills',
    'Margate',
    'Woody Point',
    'Newstead',
    'Bowen Hills',
    'Chermside',
    'Brighton (Qld)',
    'The Hills District',
    'Wilston',
    'Auchenflower',
    'Ashgrove',
    'Wolffdene',
    'Bahrs Scrub',
    'Kenmore',
    'St Lucia',
    'Chelmer',
    'Graceville',
    'Annerley',
    'Sunnybank',
    'Pallara',
    'Willawong',
    'Eight Mile Plains',
    'Tarragindi',
    'Wishart',
    'Shailer Park',
    'Marsden',
    'Carina',
    'Regents Park',
    'Heritage Park',
    'Mansfield (Qld)',
    'Shailer Park',
    'Bethania',
    'Waterford',
    'Belmont',
    'Gumdale',
    'Morningside',
    'Seven Hills',
    'Brisbane Port',
    'Lytton',
    'Cannon Hill',
    'Capalaba',
    'Beaudesert',
    'Manly',
    'Lota',
    'Ipswich',
    'East',
    'Edens Landing',
    'Holmview',
    'Ipswich',
    'Central',
    'Beaudesert',
    'Beaudesert',
    'Brassall',
    'Beaudesert',
    'Ipswich',
    'North',
    'Bundamba',
    'Leichhardt',
    'One Mile',
    'Ipswich',
    'Central',
    'Beaudesert',
    'Beaudesert',
    'Beaudesert',
    'Beaudesert',
    'Springfield',
    'Redbank Plains',
    'Bundamba',
    'Karalee',
    'Barellan Point',
    'North Ipswich',
    'Tivoli',
    'Karana Downs',
    'Beaudesert',
    'Rosewood',
    'Camira',
    'Gailes',
    'Rosewood',
    'North Ipswich',
    'Tivoli',
    'Redbank Plains',
    'Ripley',
    'Leichhardt',
    'One Mile',
    'Rosewood',
    'Burpengary',
    'Rosewood',
    'Caboolture',
    'South',
    'Samford Valley',
    'Brisbane City',
    'Beachmere',
    'Sandstone Point',
    'Strathpine',
    'Brendale',
    'Dayboro',
    'Beachmere',
    'Sandstone Point',
    'Beaudesert',
    'Churchill',
    'Yamanto',
    'Springfield',
    'Churchill',
    'Yamanto',
    'Ipswich',
    'East',
    'Rosewood',
    'Bribie Island',
    'Ripley',
    'Beaudesert',
    'Beaudesert',
    'Churchill',
    'Yamanto',
    'Collingwood Park',
    'Redbank',
    'Ipswich',
    'Central',
    'Ripley',
    'Rosewood',
    'Beaudesert',
    'Beaudesert',
    'Beaudesert',
    'Goodna',
    'New Chum',
    'Brassall',
    'Narangba',
    'Rosewood',
    'Upper Caboolture',
    'Beaudesert',
    'Dayboro',
    'Karana Downs',
    'Beaudesert',
    'Rosewood',
    'Beaudesert',
    'Rosewood',
    'Ipswich',
    'East',
    'Rosewood',
    'Raceview',
    'Lawnton',
    'Bribie Island',
    'Bribie Island',
    'Rosewood',
    'Bribie Island',
    'Dayboro',
    'Logan Village',
    'Beaudesert',
    'Camira',
    'Gailes',
    'Ipswich',
    'East',
    'Ipswich',
    'Central',
    'Beaudesert',
    'Rosewood',
    'Springfield Lakes',
    'Rosewood',
    'Ipswich',
    'East',
    'Burpengary',
    'East',
    'Rosewood',
    'Ripley',
    'Ipswich',
    'North',
    'Beachmere',
    'Sandstone Point',
    'Bundamba',
    'Elimbah',
    'Ipswich',
    'Central',
    'Samford Valley',
    'Leichhardt',
    'One Mile',
    'Goodna',
    'Rosewood',
    'Ipswich',
    'East',
    'Beaudesert',
    'Karana Downs',
    'Raceview',
    'Rosewood',
    'Strathpine',
    'Brendale',
    'Beaudesert',
    'Beachmere',
    'Sandstone Point',
    'Beaudesert',
    'Samford Valley',
    'Riverview',
    'Dayboro',
    'Rosewood',
    'Goodna',
    'Brisbane City',
    'Ipswich',
    'East',
    'Raceview',
    'Rosewood',
    'Rosewood',
    'Brisbane City',
    'Ipswich',
    'North',
    'Samford Valley',
    'Rosewood',
    'Dayboro',
    'Beaudesert',
    'Murrumba Downs',
    'Griffin',
    'Bundamba',
    'Upper Caboolture',
    'Rosewood',
    'Bribie Island',
    'Rosewood',
    'Wamuran',
    'Upper Caboolture',
    'Dayboro',
    'Beachmere',
    'Sandstone Point',
    'Strathpine',
    'Brendale',
    'Samford Valley',
    'Caboolture',
    'South',
    'Beaudesert',
    'Samford Valley',
    'Beaudesert',
    'Dayboro',
    'Collingwood Park',
    'Redbank',
    'Murrumba Downs',
    'Griffin',
    'North Ipswich',
    'Tivoli',
    'Murrumba Downs',
    'Griffin',
    'Karana Downs',
    'Dayboro',
    'Petrie',
    'Salisbury',
    'Nathan',
    'Bribie Island',
    'Bribie Island',
    'Samford Valley',
    'Samford Valley',
    'Samford Valley',
    'Strathpine',
    'Brendale',
    'Dayboro',
    'Burpengary',
    'Cashmere',
    'Dayboro',
    'Samford Valley',
    'Brisbane City',
    'Strathpine',
    'Brendale',
    'Brisbane City',
    'Caboolture',
    'South',
    'Northgate',
    'Virginia',
    'Samford Valley',
    'Brisbane City',
    'Dayboro',
    'Beachmere',
    'Sandstone Point',
    'Samford Valley',
    'Cashmere',
    'Dayboro',
    'Bray Park',
    'Bribie Island',
    'Wamuran',
    'Strathpine',
    'Brendale',
    'Deception Bay',
    'Samford Valley',
    'Petrie',
    'Beachmere',
    'Sandstone Point',
    'Samford Valley',
    'Cashmere',
    'Bribie Island',
    'Brisbane City',
    'Brisbane City',
    'Brisbane City',
    'Alexandra Hills',
    'Brisbane',
    'Belmont',
    'Gumdale',
    'Birkdale',
    'Capalaba',
    'Thorneside',
    'Wellington Point',
    'Tenerife',
    'Cleveland',
    'Ormiston',
    'Redland Bay',
    'Sheldon',
    'Mount Cotton',
    'Thornlands',
    'Victoria Point',
    'Brisbane Port',
    'Lytton',
    'Manly',
    'Lota',
    'Manly West',
    'Murarrie',
    'Tingalpa',
    'Wakerley',
    'Wynnum',
    'Wynnum West',
    'Hemmant',
    'Bald Hills',
    'Bridgeman Downs',
    'Carseldine',
    'Everton Park',
    'McDowall',
    'Aspley',
    'Chermside',
    'Chermside West',
    'Geebung',
    'Kedron',
    'Gordon Park',
    'Stafford',
    'Stafford Heights',
    'Wavell Heights',
    'Boondall',
    'Brisbane Airport',
    'Eagle Farm',
    'Pinkenba',
    'Northgate',
    'Virginia',
    'Nudgee',
    'Banyo',
    'Nundah',
    'Bracken Ridge',
    'Brighton',
    'Deagon',
    'Sandgate',
    'Shorncliffe',
    'Taigum',
    'Fitzgibbon',
    'Zillmere',
    'Camp Hill',
    'Cannon Hill',
    'Carina',
    'Carina Heights',
    'Carindale',
    'Annerley',
    'Coorparoo',
    'Fairfield',
    'Dutton Park',
    'Greenslopes',
    'Holland Park',
    'Holland Park West',
    'Woolloongabba',
    'Yeronga',
    'Eight Mile Plains',
    'Macgregor',
    'Mansfield',
    'Mount Gravatt',
    'Rochedale',
    'Burbank',
    'Upper Mount Gravatt',
    'Wishart',
    'Coopers Plains',
    'Moorooka',
    'Robertson',
    'Salisbury',
    'Nathan',
    'Tarragindi',
    'Algester',
    'Calamvale',
    'Stretton',
    'Pallara',
    'Willawong',
    'Parkinson',
    'Drewvale',
    'Rocklea',
    'Acacia Ridge',
    'Kuraby',
    'Runcorn',
    'Sunnybank',
    'Sunnybank Hills',
    'Jindalee',
    'Mount Ommaney',
    'Middle Park',
    'Jamboree Heights',
    'Riverhills',
    'Seventeen Mile Rocks',
    'Sinnamon Park',
    'Westlake',
    'Bellbowrie',
    'Moggill',
    'Brookfield',
    'Kenmore Hills',
    'Chapel Hill',
    'Fig Tree Pocket',
    'Kenmore',
    'Pinjarra Hills',
    'Pullenvale',
    'Chelmer',
    'Graceville',
    'Corinda',
    'Indooroopilly',
    'Sherwood',
    'St Lucia',
    'Taringa',
    'Enoggera',
    'Keperra',
    'Mitchelton',
    'Mount Coot',
    'tha',
    'The Gap',
    'Upper Kedron',
    'Ferny Grove',
    'Brisbane City',
    'Brisbane Adelaide Street',
    'Fortitude Valley',
    'Highgate Hill',
    'Kangaroo Point',
    'New Farm',
    'South Brisbane',
    'Spring Hill',
    'West End',
    'Balmoral',
    'Bulimba',
    'East Brisbane',
    'Hawthorne',
    'Morningside',
    'Seven Hills',
    'Norman Park',
    'Albion',
    'Alderley',
    'Ascot',
    'Clayfield',
    'Grange',
    'Hamilton',
    'Hendra',
    'Kelvin Grove',
    'Herston',
    'Newmarket',
    'Newstead',
    'Bowen Hills',
    'Wilston',
    'Windsor',
    'Wooloowin',
    'Lutwyche',
    'Ashgrove',
    'Auchenflower',
    'Bardon',
    'Paddington',
    'Milton',
    'Red Hill',
    'Toowong',
    'Darra',
    'Sumner',
    'Durack',
    'Inala',
    'Richlands',
    'Oxley',
    'Wacol',
    'Doolandella',
    'Forest Lake',
    'Ellen Grove',
    'Rosewood',
    'Brassall',
    'Bundamba',
    'Churchill',
    'Yamanto',
    'Ipswich',
    'Central',
    'Ipswich',
    'East',
    'Ipswich',
    'North',
    'Karalee',
    'Barellan Point',
    'Karana Downs',
    'Leichhardt',
    'One Mile',
    'North Ipswich',
    'Tivoli',
    'Raceview',
    'Ripley',
    'Riverview',
    'Camira',
    'Gailes',
    'Carole Park',
    'Collingwood Park',
    'Redbank',
    'Goodna',
    'New Chum',
    'Redbank Plains',
    'Springfield',
    'Springfield Lakes',
    'Augustine Heights',
    'Brookwater',
    'Bellbird Park',
    'Beaudesert',
    'Beenleigh',
    'Eagleby',
    'Edens Landing',
    'Holmview',
    'Mount Warren Park',
    'Wolffdene',
    'Bahrs Scrub',
    'Boronia Heights',
    'Park Ridge',
    'Browns Plains',
    'Chambers Flat',
    'Logan Reserve',
    'Crestmead',
    'Greenbank Military Camp',
    'Hillcrest',
    'Marsden',
    'Munruben',
    'Park Ridge South',
    'Regents Park',
    'Heritage Park',
    'Logan Village',
    'Flagstone',
    'Riverbend',
    'Flagstone',
    'New Beith',
    'Greenbank',
    'North Maclean',
    'Jimboomba',
    'Glenlogan',
    'Yarrabilba',
    'Bethania',
    'Waterford',
    'Cornubia',
    'Carbrook',
    'Loganholme',
    'Tanah Merah',
    'Loganlea',
    'Shailer Park',
    'Waterford West',
    'Daisy Hill',
    'Kingston',
    'Logan Central',
    'Rochedale South',
    'Priestdale',
    'Slacks Creek',
    'Springwood',
    'Underwood',
    'Woodridge',
    'Beachmere',
    'Sandstone Point',
    'Bribie Island',
    'Burpengary',
    'East',
    'Caboolture',
    'South',
    'Elimbah',
    'Morayfield',
    'East',
    'Wamuran',
    'Caboolture',
    'East',
    'Caboolture',
    'West',
    'Burpengary',
    'Deception Bay',
    'Morayfield',
    'Narangba',
    'Upper Caboolture',
    'Clontarf',
    'Margate',
    'Woody Point',
    'Redcliffe',
    'Rothwell',
    'Kippa',
    'Ring',
    'Scarborough',
    'Newport',
    'Albany Creek',
    'Cashmere',
    'Dayboro',
    'Eatons Hill',
    'The Hills District',
    'Samford Valley',
    'Murrumba Downs',
    'Griffin',
    'Dakabin',
    'Kallangur',
    'Mango Hill',
    'North Lakes',
    'Bray Park',
    'Lawnton',
    'Petrie',
    'Strathpine',
    'Brendale',
    'BRISBANE ADELAIDE STREET',
    'BRISBANE CITY',
    'BRISBANE GPO',
    'PETRIE TERRACE',
    'SPRING HILL',
    'BRISBANE',
    'CITY EAST',
    'GEORGE STREET',
    'SPRING HILL',
    'NEW FARM',
    'TENERIFFE',
    'BOWEN HILLS',
    'FORTITUDE VALLEY',
    'FORTITUDE VALLEY BC',
    'HERSTON',
    'NEWSTEAD',
    'ASCOT',
    'HAMILTON',
    'HAMILTON CENTRAL',
    'BRISBANE AIRPORT',
    'PINKENBA',
    'EAGLE FARM',
    'EAGLE FARM BC',
    'ALBION',
    'ALBION BC',
    'ALBION DC',
    'CLAYFIELD',
    'HENDRA',
    'NUNDAH',
    'TOOMBUL',
    'WAVELL HEIGHTS',
    'WAVELL HEIGHTS NORTH',
    'NORTHGATE',
    'BANYO',
    'NUDGEE',
    'NUDGEE BEACH',
    'VIRGINIA',
    'VIRGINIA BC',
    'VIRGINIA DC',
    'BRACKEN RIDGE',
    'BRIGHTON',
    'BRIGHTON EVENTIDE',
    'BRIGHTON NATHAN STREET',
    'DEAGON',
    'SANDGATE',
    'SANDGATE DC',
    'SHORNCLIFFE',
    'FITZGIBBON',
    'TAIGUM',
    'CLONTARF',
    'CLONTARF BEACH',
    'CLONTARF DC',
    'MARGATE',
    'MARGATE BEACH',
    'WOODY POINT',
    'NEWPORT',
    'REDCLIFFE',
    'REDCLIFFE NORTH',
    'SCARBOROUGH',
    'KIPPA-RING',
    'ROTHWELL',
    'ROYAL BRISBANE HOSPITAL',
    'KALINGA',
    'LUTWYCHE',
    'WINDSOR',
    'WOOLOOWIN',
    'GORDON PARK',
    'KEDRON',
    'CHERMSIDE',
    'CHERMSIDE CENTRE',
    'CHERMSIDE SOUTH',
    'CHERMSIDE WEST',
    'ASPLEY',
    'BOONDALL',
    'CARSELDINE',
    'GEEBUNG',
    'ZILLMERE',
    'ALBANY CREEK',
    'BRIDGEMAN DOWNS',
    'BALD HILLS',
    'EATONS HILL',
    'ALDERLEY',
    'ENOGGERA',
    'GAYTHORNE',
    'GRANGE',
    'NEWMARKET',
    'WILSTON',
    'BROOKSIDE CENTRE',
    'EVERTON HILLS',
    'EVERTON PARK',
    'MCDOWALL',
    'MITCHELTON',
    'STAFFORD',
    'STAFFORD DC',
    'STAFFORD HEIGHTS',
    'ARANA HILLS',
    'KEPERRA',
    'BUNYA',
    'FERNY GROVE',
    'FERNY HILLS',
    'FERNY HILLS DC',
    'UPPER KEDRON',
    'KELVIN GROVE',
    'KELVIN GROVE DC',
    'RED HILL',
    'ASHGROVE',
    'ASHGROVE EAST',
    'THE GAP',
    'MILTON',
    'MILTON BC',
    'PADDINGTON',
    'BARDON',
    'AUCHENFLOWER',
    'MOUNT COOT-THA',
    'TOOWONG',
    'TOOWONG BC',
    'TOOWONG DC',
    'ST LUCIA',
    'ST LUCIA SOUTH',
    'CHELMER',
    'INDOOROOPILLY',
    'INDOOROOPILLY CENTRE',
    'TARINGA',
    'BROOKFIELD',
    'CHAPEL HILL',
    'FIG TREE POCKET',
    'KENMORE',
    'KENMORE DC',
    'KENMORE EAST',
    'KENMORE HILLS',
    'PINJARRA HILLS',
    'PULLENVALE',
    'UPPER BROOKFIELD',
    'ANSTEAD',
    'BELLBOWRIE',
    'MOGGILL',
    'UNIVERSITY OF QUEENSLAND',
    'SEVENTEEN MILE ROCKS',
    'SINNAMON PARK',
    'JAMBOREE HEIGHTS',
    'JINDALEE',
    'MIDDLE PARK',
    'MOUNT OMMANEY',
    'RIVERHILLS',
    'SUMNER',
    'SUMNER PARK BC',
    'WESTLAKE',
    'CORINDA',
    'GRACEVILLE',
    'GRACEVILLE EAST',
    'OXLEY',
    'SHERWOOD',
    'DARRA',
    'WACOL',
    'DOOLANDELLA',
    'DURACK',
    'INALA',
    'INALA HEIGHTS',
    'RICHLANDS',
    'ELLEN GROVE',
    'FOREST LAKE',
    'HIGHGATE HILL',
    'SOUTH BRISBANE',
    'SOUTH BRISBANE BC',
    'WEST END',
    'DUTTON PARK',
    'WOOLLOONGABBA',
    'ANNERLEY',
    'FAIRFIELD',
    'FAIRFIELD GARDENS',
    'YERONGA',
    'MOOROOKA',
    'TENNYSON',
    'YEERONGPILLY',
    'BRISBANE MARKET',
    'ROCKLEA',
    'ROCKLEA DC',
    'SALISBURY',
    'SALISBURY EAST',
    'ARCHERFIELD',
    'ARCHERFIELD BC',
    'COOPERS PLAINS',
    'MACGREGOR',
    'ROBERTSON',
    'SUNNYBANK',
    'SUNNYBANK HILLS',
    'SUNNYBANK SOUTH',
    'ACACIA RIDGE',
    'HEATHWOOD',
    'HEATHWOOD DF',
    'LARAPINTA',
    'PALLARA',
    'WILLAWONG',
    'NATHAN',
    'KURABY',
    'EIGHT MILE PLAINS',
    'RUNCORN',
    'KINGSTON',
    'LOGAN CENTRAL',
    'LOGAN CITY DC',
    'WOODRIDGE',
    'ALGESTER',
    'PARKINSON',
    'CALAMVALE',
    'DREWVALE',
    'STRETTON',
    'BERRINBA',
    'KARAWATHA',
    'BROWNS PLAINS',
    'FORESTDALE',
    'HERITAGE PARK',
    'HILLCREST',
    'REGENTS PARK',
    'UNDERWOOD',
    'GREENSLOPES',
    'STONES CORNER',
    'HOLLAND PARK',
    'HOLLAND PARK EAST',
    'HOLLAND PARK WEST',
    'TARRAGINDI',
    'WELLERS HILL',
    'MANSFIELD',
    'MANSFIELD BC',
    'MANSFIELD DC',
    'MOUNT GRAVATT',
    'MOUNT GRAVATT EAST',
    'UPPER MOUNT GRAVATT',
    'UPPER MOUNT GRAVATT BC',
    'WISHART',
    'ROCHEDALE',
    'ROCHEDALE SOUTH',
    'BORONIA HEIGHTS',
    'GREENBANK',
    'LYONS',
    'NEW BEITH',
    'SILVERBARK RIDGE',
    'MUNRUBEN',
    'PARK RIDGE',
    'PARK RIDGE SOUTH',
    'DAISY HILL',
    'PRIESTDALE',
    'SLACKS CREEK',
    'SPRINGWOOD',
    'SHAILER PARK',
    'TANAH MERAH',
    'LOGANHOLME',
    'LOGANHOLME BC',
    'LOGANHOLME DC',
    'CARBROOK',
    'CORNUBIA',
    'LOGANLEA',
    'MEADOWBROOK',
    'CRESTMEAD',
    'MARSDEN',
    'CHAMBERS FLAT',
    'LOGAN RESERVE',
    'WATERFORD',
    'WATERFORD WEST',
    'COORPAROO',
    'COORPAROO DC',
    'CAMP HILL',
    'CARINA',
    'CARINA HEIGHTS',
    'CARINDALE',
    'BELMONT',
    'GUMDALE',
    'RANSOME',
    'WAKERLEY',
    'CHANDLER',
    'BURBANK',
    'MACKENZIE',
    'CAPALABA',
    'CAPALABA BC',
    'CAPALABA DC',
    'SHELDON',
    'THORNESIDE',
    'BIRKDALE',
    'ORMISTON',
    'WELLINGTON POINT',
    'ALEXANDRA HILLS',
    'CLEVELAND',
    'CLEVELAND DC',
    'THORNLANDS',
    'MOUNT COTTON',
    'REDLAND BAY',
    'VICTORIA POINT',
    'VICTORIA POINT WEST',
    'EAST BRISBANE',
    'KANGAROO POINT',
    'CANNON HILL',
    'MORNINGSIDE',
    'NORMAN PARK',
    'SEVEN HILLS',
    'BALMORAL',
    'BULIMBA',
    'HAWTHORNE',
    'MURARRIE',
    'TINGALPA',
    'TINGALPA DC',
    'HEMMANT',
    'LYTTON',
    'PORT OF BRISBANE',
    'WYNNUM',
    'WYNNUM NORTH',
    'WYNNUM PLAZA',
    'WYNNUM WEST',
    'LOTA',
    'MANLY',
    'MANLY WEST',
    'BETHANIA',
    'ALBERTON',
    'BAHRS SCRUB',
    'BANNOCKBURN',
    'BEENLEIGH',
    'BELIVAH',
    'BUCCAN',
    'CEDAR CREEK',
    'EAGLEBY',
    'EDENS LANDING',
    'HOLMVIEW',
    'KAIRABAH',
    'LOGAN VILLAGE',
    'LUSCOMBE',
    'MOUNT WARREN PARK',
    'STAPYLTON',
    'STEIGLITZ',
    'WINDAROO',
    'WOLFFDENE',
    'WOONGOOLBA',
    'YARRABILBA',
    'YATALA',
    'YATALA DC',
    'BENOBBLE',
    'BIDDADDABA',
    'BOYLAND',
    'CANUNGRA',
    'FERNY GLEN',
    'FLYING FOX',
    'ILLINBAH',
    "O'REILLY",
    'SARABAH',
    'WITHEREN',
    'WONGLEPONG',
    'FLAGSTONE',
    'GLENLOGAN',
    'JIMBOOMBA',
    'NORTH MACLEAN',
    'RIVERBEND',
    'SOUTH MACLEAN',
    'STOCKLEIGH',
    'ALLENVIEW',
    'BEAUDESERT',
    'BIRNAM',
    'BROMELTON',
    'CAINBABLE',
    'CEDAR GROVE',
    'CEDAR VALE',
    'CHINGHEE CREEK',
    'CHRISTMAS CREEK',
    'CRYNA',
    'DARLINGTON',
    'FLINDERS LAKES',
    'GLENEAGLE',
    'HILLVIEW',
    'INNISPLAIN',
    'JOSEPHVILLE',
    'KAGARU',
    'KERRY',
    'KNAPP CREEK',
    'KOORALBYN',
    'LAMINGTON',
    'LARAVALE',
    'MONARCH GLEN',
    'MOUNT GIPPS',
    'MUNDOOLUN',
    'NINDOOINBAH',
    'OAKY CREEK',
    'TABOOBA',
    'TABRAGALBA',
    'TAMROOKUM',
    'TAMROOKUM CREEK',
    'UNDULLAH',
    'VERESDALE',
    'VERESDALE SCRUB',
    'WOODHILL',
    'BARNEY VIEW',
    'MOUNT BARNEY',
    'MOUNT LINDESAY',
    'PALEN CREEK',
    'RATHDOWNEY',
    'RUNNING CREEK',
    'AUGUSTINE HEIGHTS',
    'BELLBIRD PARK',
    'BROOKWATER',
    'CAMIRA',
    'CAROLE PARK',
    'GAILES',
    'GOODNA',
    'SPRING MOUNTAIN',
    'SPRINGFIELD',
    'SPRINGFIELD CENTRAL',
    'SPRINGFIELD LAKES',
    'COLLINGWOOD PARK',
    'REDBANK',
    'REDBANK PLAINS',
    'DINMORE',
    'NEW CHUM',
    'RIVERVIEW',
    'BLACKSTONE',
    'BOOVAL',
    'BOOVAL FAIR',
    'BUNDAMBA',
    'EBBW VALE',
    'NORTH BOOVAL',
    'SILKSTONE',
    'BASIN POCKET',
    'BRASSALL',
    'BREMER',
    'CHURCHILL',
    'COALFALLS',
    'EAST IPSWICH',
    'EASTERN HEIGHTS',
    'FLINDERS VIEW',
    'IPSWICH',
    'LEICHHARDT',
    'LIMESTONE RIDGES',
    'MOORES POCKET',
    'NEWTOWN',
    'NORTH IPSWICH',
    'NORTH TIVOLI',
    'ONE MILE',
    'RACEVIEW',
    'SADLIERS CROSSING',
    'TIVOLI',
    'WEST IPSWICH',
    'WOODEND',
    'WULKURAKA',
    'YAMANTO',
    'AMBERLEY',
    'BANKS CREEK',
    'BARELLAN POINT',
    'BLACKSOIL',
    'BORALLON',
    'CHUWAR',
    'DEEBING HEIGHTS',
    'DUNDAS',
    'ENGLAND CREEK',
    'FAIRNEY VIEW',
    'FERNVALE',
    'GLAMORGAN VALE',
    'GOOLMAN',
    'HAIGSLEA',
    'IRONBARK',
    'KARALEE',
    'KARANA DOWNS',
    'KARRABIN',
    'KHOLO',
    'LAKE MANCHESTER',
    'LARK HILL',
    'MOUNT CROSBY',
    'MOUNT MARROW',
    'MUIRLEA',
    'PEAK CROSSING',
    'PINE MOUNTAIN',
    'PURGA',
    'RIPLEY',
    'SOUTH RIPLEY',
    'SPLIT YARD CREEK',
    'SWANBANK',
    'THAGOONA',
    'VERNOR',
    'WALLOON',
    'WANORA',
    'WASHPOOL',
    'WHITE ROCK',
    'WILLOWBANK',
    'WIVENHOE POCKET',
    'COLEYVILLE',
    'HARRISVILLE',
    'MUTDAPILLY',
    'RADFORD',
    'SILVERDALE',
    'WARRILL VIEW',
    'WILSONS PLAINS',
    'ASHWELL',
    'CALVERT',
    'EBENEZER',
    'GRANDCHESTER',
    'JEEBROPILLY',
    'LANEFIELD',
    'LOWER MOUNT WALKER',
    'MERRYVALE',
    'MOORANG',
    'MOUNT FORBES',
    'MOUNT MORT',
    'MOUNT WALKER',
    'MOUNT WALKER WEST',
    'ROSEVALE',
    'ROSEWOOD',
    'TALLEGALLA',
    'THE BLUFF',
    'WOOLSHED',
    'MARBURG',
    'BRAY PARK',
    'BRENDALE',
    'BRENDALE BC',
    'BRENDALE DC',
    'CASHMERE',
    'CLEAR MOUNTAIN',
    'JOYNER',
    'STRATHPINE',
    'STRATHPINE CENTRE',
    'WARNER',
    'LAWNTON',
    'PETRIE',
    'DAKABIN',
    'GRIFFIN',
    'KALLANGUR',
    'KURWONGBAH',
    'MURRUMBA DOWNS',
    'WHITESIDE',
    'NARANGBA',
    'BURPENGARY',
    'BURPENGARY DC',
    'BURPENGARY EAST',
    'MOORINA',
    'MORAYFIELD',
    'BANKSIA BEACH',
    'BELLARA',
    'BONGAREE',
    'BRIBIE ISLAND',
    'BRIBIE ISLAND NORTH',
    'WELSBY',
    'WHITE PATCH',
    'WOORIM',
    'DECEPTION BAY',
    'MANGO HILL',
    'NORTH LAKES',
    'BEACHMERE',
    'BELLMERE',
    'CABOOLTURE',
    'CABOOLTURE BC',
    'CABOOLTURE SOUTH',
    'DONNYBROOK',
    'MELDALE',
    'MOODLU',
    'ROCKSBERG',
    'TOORBUL',
    'UPPER CABOOLTURE',
    'GODWIN BEACH',
    'NINGI',
    'SANDSTONE POINT',
    'BRACALBA',
    'WAMURAN',
    'WAMURAN BASIN',
    'ELIMBAH',
    'ARMSTRONG CREEK',
    'CAMP MOUNTAIN',
    'CEDAR CREEK',
    'CLOSEBURN',
    'DRAPER',
    'ENOGGERA RESERVOIR',
    'HIGHVALE',
    'JOLLYS LOOKOUT',
    'KOBBLE CREEK',
    'MOUNT GLORIOUS',
    'MOUNT NEBO',
    'MOUNT SAMSON',
    'SAMFORD',
    'SAMFORD VALLEY',
    'SAMFORD VILLAGE',
    'SAMSONVALE',
    'WIGHTS MOUNTAIN',
    'YUGAR',
    'CAMPBELLS POCKET',
    'DAYBORO',
    'KING SCRUB',
    'LACEYS CREEK',
    'MOUNT MEE',
    'MOUNT PLEASANT',
    'OCEAN VIEW',
    'RUSH CREEK',
    'BAMBOO CREEK',
    'BELVEDERE',
    'COCONUTS',
    'COOROO LANDS',
    'COORUMBA',
    'COQUETTE POINT',
    'CULLINANE',
    'DARADGEE',
    'EAST INNISFAIL',
    'EAST PALMERSTON',
    'EATON',
    'EUBENANGEE',
    'FITZGERALD CREEK',
    'FLYING FISH POINT',
    'GARRADUNGA',
    'GOONDI',
    'GOONDI BEND',
    'GOONDI HILL',
    'HUDSON',
    'INNISFAIL',
    'INNISFAIL ESTATE',
    'JUBILEE HEIGHTS',
    'MIGHELL',
    'MUNDOO',
    'NERADA',
    'NGATJAN',
    "O'BRIENS HILL",
    'PALMERSTON',
    'PIN GIN HILL',
    'SOUTH INNISFAIL',
    'STOTERS HILL',
    'SUNDOWN',
    'UPPER DARADGEE',
    'VASA VIEWS',
    'WANJURU',
    'WEBB',
    'WOOROONOORAN',
    'BRISBANE',
    'BRISBANE',
    'BRISBANE',
    'BRISBANE',
    'BRISBANE',
    'BRISBANE',
    'BRISBANE',
    'BRISBANE',
    'BRISBANE',
    'NORTHGATE MC',
  ],
  VIC: [
    'Docklands',
    'Seddon',
    'Kingsville',
    'Laverton',
    'Sunshine',
    'Maribyrnong',
    'Hoppers Crossing',
    'North',
    'Gladstone Park',
    'Westmeadows',
    'Gladstone Park',
    'Westmeadows',
    'Blackburn',
    'Greenvale',
    'Bulla',
    'Ferntree Gully (South)',
    'Upper Ferntree Gully',
    'Mill Park',
    'North',
    'Oakleigh',
    'Huntingdale',
    'Kew East',
    'Dandenong North',
    'Box Hill',
    'Brighton East',
    'Ringwood East',
    'Chelsea',
    'Bonbeach',
    'Ashburton (Vic.)',
    'Minto',
    'St Andrews',
    'Ferntree Gully (North)',
    'Newport',
    'Oakleigh',
    'Huntingdale',
    'Caroline Springs',
    'Beaumaris',
    'Niddrie',
    'Essendon West',
    'Moorabbin',
    'Heatherton',
    'Campbellfield',
    'Coolaroo',
    'Newport',
    'Ivanhoe',
    'Sydenham',
    'Montmorency',
    'Briar Hill',
    'Preston',
    'East',
    'Templestowe Lower',
    'Kingsbury',
    'Camberwell',
    'Doncaster East (South)',
    'Forest Hill',
    'Surrey Hills (West)',
    'Canterbury',
    'Bayswater North',
    'Wandin',
    'Seville',
    'Wantirna',
    'Malvern East',
    'Caulfield',
    'North',
    'Belgrave',
    'Selby',
    'Noble Park',
    'West',
    'Dingley Village',
    'St Kilda East',
    'Knoxfield',
    'Scoresby',
    'Edithvale',
    'Aspendale',
    'Cheltenham',
    'Highett (East)',
    'Melton West',
    'Bentleigh',
    'McKinnon',
    'Seddon',
    'Kingsville',
    'Emerald',
    'Cockatoo',
    'Taylors Lakes',
    'Point Cook',
    'East',
    'Whittlesea',
    'Pascoe Vale South',
    'Heidelberg',
    'Rosanna',
    'Preston',
    'West',
    'Research',
    'North Warrandyte',
    'Plenty',
    'Yarrambat',
    'Ringwood North',
    'Doncaster East (South)',
    'Malvern',
    'Glen Iris',
    'Box Hill North',
    'Glen Waverley',
    'West',
    'Yarra Valley',
    'Bentleigh East (North)',
    'Ashwood',
    'Chadstone',
    'Moorabbin',
    'Heatherton',
    'Belgrave',
    'Selby',
    'Carrum',
    'Patterson Lakes',
    'Doveton',
    'Yarraville',
    'Braeside',
    'Sunshine West',
    'Carrum Downs',
    'Moonee Ponds',
    'Rockbank',
    'Mount Cottrell',
    'Meadow Heights',
    'Braybrook',
    'Brunswick East',
    'Altona North',
    'Preston',
    'West',
    'Flemington',
    'Watsonia',
    'Niddrie',
    'Essendon West',
    'Hurstbridge',
    'Brunswick West',
    'Research',
    'North Warrandyte',
    'Mickleham',
    'Yuroke',
    'Burwood',
    'Epping',
    'West',
    'Kilsyth',
    'Plenty',
    'Yarrambat',
    'Wheelers Hill',
    'Balwyn',
    'Brighton (Vic.)',
    'Ringwood',
    'Chelsea Heights',
    'Malvern',
    'Glen Iris',
    'Port Melbourne',
    'Caulfield',
    'North',
    'Greenvale',
    'Bulla',
    'Prahran',
    'Windsor',
    'Wallan',
    'Cheltenham',
    'Highett (East)',
    'Yarra Valley',
    'Bentleigh',
    'McKinnon',
    'Yarra Valley',
    'Monbulk',
    'Silvan',
    'Emerald',
    'Cockatoo',
    'Rosebud',
    'McCrae',
    'Dromana',
    'Cranbourne South',
    'Pearcedale',
    'Tooradin',
    'Pearcedale',
    'Tooradin',
    'Mount Dandenong',
    'Olinda',
    'Narre Warren',
    'South West',
    'Mount Dandenong',
    'Olinda',
    'Somerville',
    'Narre Warren North',
    'Point Nepean',
    'Langwarrin',
    'Whittlesea',
    'Cranbourne South',
    'Yarra Valley',
    'Whittlesea',
    'Hastings',
    'Somers',
    'Wandin',
    'Seville',
    'Hastings',
    'Somers',
    'Mount Dandenong',
    'Olinda',
    'Point Nepean',
    'Point Nepean',
    'Newport',
    'Cranbourne South',
    'Kings Park (Vic.)',
    'Somerville',
    'Point Cook',
    'South',
    'Williamstown',
    'Essendon Airport',
    'Keilor Downs',
    'Carlton',
    'Werribee',
    'South',
    'South Yarra',
    'West',
    'Strathmore',
    'Rockbank',
    'Mount Cottrell',
    'Carlton North',
    'Princes Hill',
    'Hadfield',
    'Burnside',
    'Fawkner',
    'Laverton',
    'Ivanhoe East',
    'Eaglemont',
    'Airport West',
    'Eltham',
    'Brunswick West',
    'Vermont',
    'Fitzroy',
    'Yarraville',
    'Greensborough',
    'Werribee',
    'South',
    'Kew East',
    'Taylors Lakes',
    'Burwood',
    'Brunswick West',
    'Docklands',
    'Preston',
    'West',
    'Altona',
    'Montmorency',
    'Briar Hill',
    'Rockbank',
    'Mount Cottrell',
    'Warrandyte',
    'Wonga Park',
    'Gladstone Park',
    'Westmeadows',
    'Surrey Hills (West)',
    'Canterbury',
    'Preston',
    'East',
    'Yarra Valley',
    'Ivanhoe',
    'Burwood East',
    'Montmorency',
    'Briar Hill',
    'Clayton South',
    'Fawkner',
    'Moorabbin',
    'Heatherton',
    'Thomastown',
    'Frankston South',
    'Greensborough',
    'Armadale',
    'Balwyn',
    'Ashwood',
    'Chadstone',
    'Chirnside Park',
    'Murrumbeena',
    'Box Hill North',
    'Mordialloc',
    'Parkdale',
    'Wantirna South',
    'Viewbank',
    'Yallambie',
    'Knoxfield',
    'Scoresby',
    'Box Hill North',
    'Cheltenham',
    'Highett (West)',
    'Lilydale',
    'Coldstream',
    'Frankston North',
    'Mount Waverley',
    'South',
    'Yarra Valley',
    'Footscray',
    'Malvern',
    'Glen Iris',
    'Sunshine West',
    'Bayswater North',
    'Laverton',
    'Noble Park',
    'West',
    'Brunswick East',
    'Moorabbin Airport',
    'Keilor Downs',
    'Frankston North',
    'Parkville',
    'Rockbank',
    'Mount Cottrell',
    'Greenvale',
    'Bulla',
    'Doncaster',
    'Ivanhoe East',
    'Eaglemont',
    'South Yarra',
    'West',
    'Wattle Glen',
    'Diamond Creek',
    'Braybrook',
    'Ringwood East',
    'Altona North',
    'Seddon',
    'Kingsville',
    'Delahey',
    'Ardeer',
    'Albion',
    'Gowanbrae',
    'Tullamarine',
    'St Albans',
    'North',
    'Campbellfield',
    'Coolaroo',
    'Laverton',
    'Thomastown',
    'Carlton North',
    'Princes Hill',
    'Heidelberg',
    'Rosanna',
    'Greensborough',
    'Balwyn North',
    'Surrey Hills (West)',
    'Canterbury',
    'Yarra',
    'North',
    'Mooroolbark',
    'Kingsbury',
    'West Melbourne',
    'Doncaster East (North)',
    'Ascot Vale',
    'Hawthorn East',
    'Campbellfield',
    'Coolaroo',
    'Ringwood East',
    'Fawkner',
    'Malvern East',
    'Collingwood',
    'Elsternwick',
    'Heidelberg West',
    'Elwood',
    'Research',
    'North Warrandyte',
    'Edithvale',
    'Aspendale',
    'Doncaster East (South)',
    'Armadale',
    'Warrandyte',
    'Wonga Park',
    'Mount Waverley',
    'South',
    'Malvern East',
    'Brighton (Vic.)',
    'Caulfield',
    'South',
    'Chelsea',
    'Bonbeach',
    'Prahran',
    'Windsor',
    'West Footscray',
    'Tottenham',
    'Sandringham',
    'Black Rock',
    'Ardeer',
    'Albion',
    'Ormond',
    'Glen Huntly',
    'Williamstown',
    'Caulfield',
    'North',
    'Cairnlea',
    'Wantirna South',
    'Kensington (Vic.)',
    'Clarinda',
    'Oakleigh South',
    'Niddrie',
    'Essendon West',
    'Cheltenham',
    'Highett (East)',
    'Craigieburn',
    'Central',
    'Seaford (Vic.)',
    'Wattle Glen',
    'Diamond Creek',
    'Bundoora',
    'West',
    'Balwyn',
    'Templestowe',
    'Blackburn',
    'Camberwell',
    'Toorak',
    'Croydon South',
    'Endeavour Hills',
    'North',
    'Malvern East',
    'Knoxfield',
    'Scoresby',
    'Braybrook',
    'Cheltenham',
    'Highett (East)',
    'Seddon',
    'Kingsville',
    'Bentleigh',
    'McKinnon',
    'Sunshine North',
    'Kings Park (Vic.)',
    'Seabrook',
    'Werribee',
    'South',
    'Taylors Lakes',
    'Coburg North',
    'Broadmeadows',
    'Preston',
    'West',
    'Brunswick East',
    'Kingsbury',
    'Thornbury',
    'Box Hill',
    'Watsonia',
    'Wandin',
    'Seville',
    'Donvale',
    'Park Orchards',
    'Taylors Lakes',
    'Hawthorn East',
    'Mickleham',
    'Yuroke',
    'Croydon',
    'West',
    'Alphington',
    'Fairfield',
    'Malvern',
    'Glen Iris',
    'Viewbank',
    'Yallambie',
    'Hughesdale',
    'Bulleen',
    'Brighton (Vic.)',
    'Camberwell',
    'Aspendale Gardens',
    'Waterways',
    'Blackburn',
    'Albert Park',
    'Croydon Hills',
    'Warranwood',
    'Parkville',
    'Glen Waverley',
    'East',
    'Keilor',
    'Ferntree Gully (South)',
    'Upper Ferntree Gully',
    'Abbotsford',
    'Springvale',
    'Epping',
    'West',
    'St Kilda East',
    'Balwyn',
    'Mentone',
    'Hawthorn East',
    'Altona',
    'Blackburn South',
    'Altona North',
    'South Yarra',
    'West',
    'Taylors Lakes',
    'Strathmore',
    'Carlton',
    'Parkville',
    'Mickleham',
    'Yuroke',
    'Preston',
    'East',
    'Viewbank',
    'Yallambie',
    'Heidelberg West',
    'Burwood',
    'Donvale',
    'Park Orchards',
    'Croydon Hills',
    'Warranwood',
    'Surrey Hills (East)',
    'Mont Albert',
    'Sunshine West',
    'Donvale',
    'Park Orchards',
    'Ardeer',
    'Albion',
    'Wandin',
    'Seville',
    'Altona Meadows',
    'The Basin',
    'Keilor',
    'Caulfield',
    'South',
    'Heidelberg West',
    'Hampton',
    'East Melbourne',
    'Frankston',
    'Werribee',
    'West',
    'Maribyrnong',
    'Flemington',
    'Coburg North',
    'Melbourne Airport',
    'Preston',
    'East',
    'Malvern East',
    'Eltham',
    'Carnegie',
    'Warrandyte',
    'Wonga Park',
    'Prahran',
    'Windsor',
    'Nunawading',
    'Mordialloc',
    'Parkdale',
    'Wandin',
    'Seville',
    'Surrey Hills (West)',
    'Canterbury',
    'West Footscray',
    'Tottenham',
    'Vermont South',
    'Burnside Heights',
    'Yarra Valley',
    'Taylors Hill',
    'Boronia',
    'Broadmeadows',
    'Ormond',
    'Glen Huntly',
    'Collingwood',
    'Moorabbin',
    'Heatherton',
    'Alphington',
    'Fairfield',
    'Frankston North',
    'Kingsbury',
    'Burwood',
    'Braybrook',
    'Rockbank',
    'Mount Cottrell',
    'Keilor',
    'Mulgrave',
    'Parkville',
    'Rowville',
    'Central',
    'Fitzroy North',
    'Hampton',
    'Malvern',
    'Glen Iris',
    'Frankston North',
    'Wantirna South',
    'Wallan',
    'Oakleigh',
    'Huntingdale',
    'Yarra Valley',
    'Sandringham',
    'Black Rock',
    'Whittlesea',
    'Carrum',
    'Patterson Lakes',
    'Emerald',
    'Cockatoo',
    'Bulleen',
    'Yarra Valley',
    'Camberwell',
    'Emerald',
    'Cockatoo',
    'Forest Hill',
    'Belgrave',
    'Selby',
    'Croydon Hills',
    'Warranwood',
    'Hastings',
    'Somers',
    'Burwood East',
    'Point Nepean',
    'Belgrave',
    'Selby',
    'Somerville',
    'Springvale South',
    'Rosebud',
    'McCrae',
    'Elwood',
    'Pearcedale',
    'Tooradin',
    'Mordialloc',
    'Parkdale',
    'Box Hill',
    'Surrey Hills (West)',
    'Canterbury',
    'Ringwood East',
    'Mitcham (Vic.)',
    'Wheelers Hill',
    'Yarra Valley',
    'Lysterfield',
    'Bayswater',
    'Springvale',
    'Caulfield',
    'South',
    'Beaumaris',
    'Brighton (Vic.)',
    'Wallan',
    'Frankston',
    'Mount Dandenong',
    'Olinda',
    'Sunbury',
    'Montrose',
    'Wallan',
    'Mount Dandenong',
    'Olinda',
    'Yarra Valley',
    'Endeavour Hills',
    'South',
    'Yarra Valley',
    'Narre Warren North',
    'Mount Dandenong',
    'Olinda',
    'Mount Eliza',
    'Rosebud',
    'McCrae',
    'Cranbourne South',
    'Rosebud',
    'McCrae',
    'Hastings',
    'Somers',
    'Belgrave',
    'Selby',
    'Hastings',
    'Somers',
    'Oakleigh',
    'Huntingdale',
    'Pearcedale',
    'Tooradin',
    'Elsternwick',
    'Cranbourne',
    'Aspendale Gardens',
    'Waterways',
    'Ashwood',
    'Chadstone',
    'Wallan',
    'Upwey',
    'Tecoma',
    'Wallan',
    'St Kilda East',
    'Emerald',
    'Cockatoo',
    'Sandringham',
    'Black Rock',
    'Wallan',
    'Albert Park',
    'Monbulk',
    'Silvan',
    'Rockbank',
    'Mount Cottrell',
    'Lilydale',
    'Coldstream',
    'Rockbank',
    'Mount Cottrell',
    'Yarra Valley',
    'Whittlesea',
    'Hastings',
    'Somers',
    'South Morang (South)',
    'Point Nepean',
    'Mount Evelyn',
    'Hastings',
    'Somers',
    'Yarra Valley',
    'Pearcedale',
    'Tooradin',
    'Wallan',
    'Dromana',
    'Rosebud',
    'McCrae',
    'Upwey',
    'Tecoma',
    'Monbulk',
    'Silvan',
    'Dandenong North',
    'Berwick',
    'North',
    'Caulfield',
    'South',
    'Hastings',
    'Somers',
    'Seaford (Vic.)',
    'Point Nepean',
    'Wollert',
    'Cranbourne South',
    'Emerald',
    'Cockatoo',
    'Heidelberg',
    'Rosanna',
    'Narre Warren',
    'South West',
    'Box Hill',
    'Mount Dandenong',
    'Olinda',
    'Yarra Valley',
    'Mount Dandenong',
    'Olinda',
    'Mount Waverley',
    'North',
    'South Morang (South)',
    'Bentleigh East (North)',
    'Mount Eliza',
    'Noble Park',
    'East',
    'Hastings',
    'Somers',
    'Elsternwick',
    'Somerville',
    'Mentone',
    'Dromana',
    'Rockbank',
    'Mount Cottrell',
    'Skye',
    'Sandhurst',
    'Wallan',
    'Christies Beach',
    'Mount Dandenong',
    'Olinda',
    'Cranbourne West',
    'Emerald',
    'Cockatoo',
    'Heidelberg West',
    'Whittlesea',
    'Balwyn North',
    'Yarra Valley',
    'Camberwell',
    'Whittlesea',
    'Mitcham (Vic.)',
    'Hallam',
    'Belgrave',
    'Selby',
    'Langwarrin',
    'Mulgrave',
    'Point Nepean',
    'Doveton',
    'Cranbourne South',
    'Hampton',
    'Lynbrook',
    'Lyndhurst',
    'Frankston',
    'Albert Park',
    'Melton West',
    'East Melbourne',
    'Wallan',
    'South Yarra',
    'West',
    'Emerald',
    'Cockatoo',
    'Emerald',
    'Cockatoo',
    'Narre Warren South (East)',
    'Lilydale',
    'Coldstream',
    'Mount Dandenong',
    'Olinda',
    'Emerald',
    'Cockatoo',
    'Lynbrook',
    'Lyndhurst',
    'Skye',
    'Sandhurst',
    'Mount Martha',
    'Docklands',
  ],
};
